<div class="menubar-hoverable header-fixed menubar-pin" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  ">
<div id="base">
<div id="content">
<div class="gv2-page" (click)="closeActionMenu()">
  <div class="gv2-header">
    <div>
      <h1 class="gv2-title">{{ 'groupsV2.manageGroups' | translate }}</h1>
      <p class="gv2-subtitle">{{ 'groupsV2.createAndManageStaffsStudents' | translate }}</p>
    </div>

    <div class="gv2-header-actions" *ngIf="activeTab === 'student'">
      <select class="gv2-native-select gv2-academic-year-select" [ngModel]="currentAcademicId"
              (ngModelChange)="academicChanged($event)" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let ac of academicList" [ngValue]="ac.pkAcademicId">
          {{ ac.Year }}<ng-container *ngIf="ac.current"> ({{ 'groupsV2.current' | translate }})</ng-container>
        </option>
      </select>
      <div class="gv2-add-student-wrap" *ngIf="(permissions.ADD_STUDENT === 'ENABLED' || permissions.IMPORT_STUDENT === 'ENABLED') && currentAcademicState === 'RUNNING'">
        <button type="button" class="gv2-add-student-btn" (click)="toggleAddStudentMenu(); $event.stopPropagation()">
          <i class="ri-add-line"></i> {{ 'groupsV2.addStudent' | translate }} <i class="ri-arrow-down-s-line"></i>
        </button>
        <ul class="gv2-action-menu gv2-add-student-menu" *ngIf="addStudentMenuOpen">
          <li (click)="addNewStudentButton()" *ngIf="permissions.ADD_STUDENT === 'ENABLED'">
            <i class="ri-user-add-line"></i> {{ 'groupsV2.addStudent' | translate }}
          </li>
          <li (click)="openStudentImportForm()" *ngIf="permissions.IMPORT_STUDENT === 'ENABLED'">
            <i class="ri-upload-2-line"></i> {{ 'groupsV2.importStudent' | translate }}
          </li>
        </ul>
      </div>
    </div>

    <div class="gv2-header-actions" *ngIf="activeTab === 'staff'">
      <div class="gv2-add-student-wrap"
        *ngIf="permissions.ADD_STAFF === 'ENABLED' || permissions.ADD_DESIGNATION === 'ENABLED' || permissions.ADD_QUALIFICATION === 'ENABLED'">
        <button type="button" class="gv2-add-student-btn" (click)="toggleAddStaffMenu(); $event.stopPropagation()">
          <i class="ri-add-line"></i> {{ 'groupsV2.addStaff' | translate }} <i class="ri-arrow-down-s-line"></i>
        </button>
        <ul class="gv2-action-menu gv2-add-student-menu" *ngIf="addStaffMenuOpen">
          <li (click)="openAddStaffForm()" *ngIf="permissions.ADD_STAFF === 'ENABLED'"><i class="ri-user-add-line"></i> {{ 'groupsV2.addStaff' | translate }}</li>
          <li (click)="openDesignationPopup()" *ngIf="permissions.ADD_DESIGNATION === 'ENABLED'"><i class="ri-award-line"></i> {{ 'groupsV2.designation' | translate }}</li>
          <li (click)="openQualificationPopup()" *ngIf="permissions.ADD_QUALIFICATION === 'ENABLED'"><i class="ri-graduation-cap-line"></i> {{ 'groupsV2.qualification' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="gv2-card">
    <!-- Tabs -->
    <div class="gv2-tabs">
      <button type="button" class="gv2-tab" [class.active]="activeTab === 'student'" (click)="switchTab('student')"
        *ngIf="permissions.SCHOOL_STUDENT_MANAGEMENT === 'ENABLED'">
        <i class="ri-graduation-cap-line"></i> {{ 'groupsV2.students' | translate }}
      </button>
      <button type="button" class="gv2-tab" [class.active]="activeTab === 'staff'" (click)="switchTab('staff')"
        *ngIf="permissions.SCHOOL_STAFFS_MANAGEMENT === 'ENABLED'">
        <i class="ri-team-line"></i> {{ 'groupsV2.staffs' | translate }}
      </button>
      <button type="button" class="gv2-btn-outline gv2-tabs-clear-filter-btn" *ngIf="activeTab === 'student' && hasActiveStudentFilters"
        (click)="clearStudentFilters()">
        <i class="ri-filter-off-line"></i> {{ 'groupsV2.clearFilter' | translate }}
      </button>
      <button type="button" class="gv2-btn-outline gv2-tabs-refresh-btn" *ngIf="activeTab === 'student'"
        [disabled]="loadingStudents" (click)="fetchStudents()" title="{{ 'groupsV2.refresh' | translate }}">
        <i class="ri-refresh-line"></i> {{ 'groupsV2.refresh' | translate }}
      </button>
      <button type="button" class="gv2-btn-outline gv2-tabs-clear-filter-btn" *ngIf="activeTab === 'staff' && hasActiveStaffFilters"
        (click)="clearStaffFilters()">
        <i class="ri-filter-off-line"></i> {{ 'groupsV2.clearFilter' | translate }}
      </button>
      <div class="gv2-search-box gv2-tabs-search" *ngIf="activeTab === 'student'">
        <i class="ri-search-line"></i>
        <input type="text" placeholder="{{ 'groupsV2.searchStudentsPlaceholder' | translate }}" [ngModel]="searchTerm"
               (ngModelChange)="onSearchInput($event)" [ngModelOptions]="{standalone: true}" />
        <i class="ri-close-circle-fill gv2-search-clear-icon" *ngIf="searchTerm" (click)="clearSearch()"></i>
      </div>
      <div class="gv2-search-box gv2-tabs-search" *ngIf="activeTab === 'staff'">
        <i class="ri-search-line"></i>
        <input type="text" placeholder="{{ 'groupsV2.searchStaffsPlaceholder' | translate }}" [ngModel]="staffSearchTerm"
               (ngModelChange)="onStaffSearchInput($event)" [ngModelOptions]="{standalone: true}" />
        <i class="ri-close-circle-fill gv2-search-clear-icon" *ngIf="staffSearchTerm" (click)="clearStaffSearch()"></i>
      </div>
    </div>

    <!-- Students tab -->
    <div class="gv2-tab-content" *ngIf="activeTab === 'student'">

      <!-- Filter row -->
      <div class="gv2-filter-row">
        <select class="gv2-pill-select" [ngModel]="selectedCategory"
                (ngModelChange)="onCategoryChange($event)" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="0">{{ 'groupsV2.allCategories' | translate }}</option>
          <option *ngFor="let category of schoolCategories" [ngValue]="category.categoryId">
            {{ category.categoryName }}
          </option>
        </select>

        <select class="gv2-pill-select" [ngModel]="selectedClass" [disabled]="classDropdownDisabled"
                (ngModelChange)="onClassChange($event)" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="0">{{ 'groupsV2.selectClass' | translate }}</option>
          <option *ngFor="let cls of schoolClasses" [ngValue]="cls.classid">{{ cls.classname }}</option>
        </select>

        <select class="gv2-pill-select" [ngModel]="selectedSection" [disabled]="sectionDropdownDisabled"
                (ngModelChange)="onSectionChange($event)" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="0">{{ 'groupsV2.selectSection' | translate }}</option>
          <option *ngFor="let sec of schoolClassesSections" [ngValue]="sec.claaSectionId">{{ sec.classSection }}</option>
        </select>

        <button type="button" class="gv2-btn-outline" *ngIf="selectedSection && permissions.EDIT_STUDENT === 'ENABLED'"
          (click)="openUpdateRollNumberPopup()">
          <i class="ri-sort-number-asc"></i> {{ 'groupsV2.updateRollNumber' | translate }}
        </button>

        <div class="gv2-export-group">
          <button type="button" class="gv2-btn-outline" (click)="exportCopy()">
            <i class="ri-file-copy-line"></i> {{ 'groupsV2.copy' | translate }}
          </button>
          <div class="gv2-column-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="gv2-btn-outline" (click)="toggleColumnDropdown()">
              <i class="ri-layout-column-line"></i> {{ 'groupsV2.columns' | translate }}
            </button>
            <ul class="gv2-column-menu" *ngIf="columnDropdownOpen">
              <li *ngFor="let col of columnOptions" (click)="toggleColumnVisibility(col)">
                <input type="checkbox" [checked]="col.visible" (click)="$event.stopPropagation(); toggleColumnVisibility(col)" />
                {{ col.labelKey | translate }}
              </li>
            </ul>
          </div>
          <div class="gv2-column-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="gv2-btn-outline" (click)="toggleExportMenu($event)">
              <i class="ri-download-2-line"></i> {{ 'groupsV2.export' | translate }} <i class="ri-arrow-down-s-line"></i>
            </button>
            <ul class="gv2-action-menu"
                [style.top.px]="exportMenuPosition?.top"
                [style.left.px]="exportMenuPosition?.left"
                *ngIf="exportMenuOpen">
              <li (click)="exportExcel(); exportMenuOpen = false"><i class="ri-file-excel-2-line"></i> {{ 'groupsV2.excel' | translate }}</li>
              <li (click)="exportCsv(); exportMenuOpen = false"><i class="ri-file-text-line"></i> {{ 'groupsV2.csv' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Selection floating bar -->
      <div class="gv2-selection-bar" *ngIf="selectedStudentIds.length > 0" (click)="$event.stopPropagation()">
        <span>{{ 'groupsV2.studentsSelected' | translate: { count: selectedStudentIds.length } }}</span>
        <div class="gv2-selection-actions">
          <button type="button" class="gv2-btn-outline" (click)="clearSelection()">{{ 'groupsV2.clear' | translate }}</button>
          <button type="button" class="gv2-btn-gradient" *ngIf="idCardServiceEnabled && isAcademicRunning" (click)="openIdCardBuilder()">{{ 'groupsV2.idCard' | translate }}</button>
          <button type="button" class="gv2-btn-gradient" *ngIf="transferCertificateEnabled" (click)="openTcBuilder()">{{ 'groupsV2.tc' | translate }}</button>
        </div>
      </div>

      <!-- Table -->
      <div class="gv2-table-wrap">
        <table class="gv2-table">
          <thead>
            <tr>
              <th>{{ 'groupsV2.sNo' | translate }}</th>
              <th class="sortable" (click)="onSortClick('registrationId')">
                {{ 'groupsV2.registrationNo' | translate }}
                <i [ngClass]="sortColumn === 'registrationId' ? (sortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th class="sortable" (click)="onSortClick('studentName')">
                {{ 'groupsV2.student' | translate }}
                <i [ngClass]="sortColumn === 'studentName' ? (sortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th>{{ 'groupsV2.parent' | translate }}</th>
              <th>{{ 'groupsV2.class' | translate }}</th>
              <th>{{ 'groupsV2.mobileNumber' | translate }}</th>
              <th class="sortable" (click)="onSortClick('dateOfAdmission')">
                {{ 'groupsV2.admissionDate' | translate }}
                <i [ngClass]="sortColumn === 'dateOfAdmission' ? (sortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th *ngFor="let col of columnOptions" [hidden]="!col.visible">{{ col.labelKey | translate }}</th>
              <th [hidden]="!(currentAcademicState === 'RUNNING' || currentAcademicState === 'NOT_STARTED')">{{ 'groupsV2.action' | translate }}</th>
              <th>
                {{ 'groupsV2.printId' | translate }}
                <input type="checkbox" [checked]="allVisibleSelected" (change)="toggleSelectAllVisible($any($event.target).checked)" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of skeletonRows" class="gv2-skeleton-row">
              <td *ngFor="let c of skeletonColumns">
                <span class="gv2-skeleton-bar"></span>
              </td>
            </tr>
            <tr *ngIf="!loadingStudents && students.length === 0">
              <td [attr.colspan]="visibleColumnCount" class="gv2-empty">{{ 'groupsV2.noStudentsFound' | translate }}</td>
            </tr>
            <ng-container *ngIf="!loadingStudents">
            <tr *ngFor="let row of students; let i = index; trackBy: trackByRowId">
              <td>{{ pageIndex * pageSize + i + 1 }}</td>
              <td>{{ row.registrationId }}</td>
              <td>
                <div class="gv2-student-cell">
                  <img class="gv2-student-avatar"
                    [src]="row.studentImage || 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png'"
                    alt="" />
                  <span>{{ row.studentName }}</span>
                </div>
              </td>
              <td>{{ row.parentName }}</td>
              <td><span class="gv2-badge">{{ row.stdClassName }}</span></td>
              <td>{{ row.mobileNumber }}</td>
              <td>{{ row.dateOfAdmission }}</td>
              <td *ngFor="let col of columnOptions" [hidden]="!col.visible">{{ formatColumnValue(col.field, row) }}</td>
              <td class="gv2-action-cell" (click)="$event.stopPropagation()" [hidden]="!(currentAcademicState === 'RUNNING' || currentAcademicState === 'NOT_STARTED')">
                <span class="gv2-action-icon" [class.gv2-action-icon-disabled]="permissions.EDIT_STUDENT !== 'ENABLED'"
                  (click)="permissions.EDIT_STUDENT === 'ENABLED' && toggleActionMenu(row, $event)">
                  <i class="ri-edit-line"></i>
                </span>
                <ul class="gv2-action-menu"
                    [style.top.px]="actionMenuPosition?.top"
                    [style.left.px]="actionMenuPosition?.left"
                    [style.transform]="actionMenuPosition?.flipUp ? 'translateY(-100%)' : null"
                    *ngIf="openActionMenuForRowId === row.DT_RowId">
                  <li (click)="openBasicInfo(row)"><i class="ri-edit-line"></i> {{ 'groupsV2.basicInfo' | translate }}</li>
                  <li (click)="documentHub(row)"><i class="ri-file-fill"></i> {{ 'groupsV2.documentHub' | translate }}</li>
                  <li (click)="openContactDetails(row)"><i class="ri-phone-line"></i> {{ 'groupsV2.contactDetails' | translate }}</li>
                  <li (click)="openTransportOptions(row)" *ngIf="currentAcademicState === 'RUNNING'"><i class="ri-bus-line"></i> {{ 'groupsV2.transportOptions' | translate }}</li>
                  <li (click)="initiateDeactivateStudent(row)" [class.gv2-action-item-disabled]="permissions.DEACTIVATE !== 'ENABLED'"><i class="ri-user-unfollow-line"></i> {{ 'groupsV2.deactivate' | translate }}</li>
                </ul>
                <span class="gv2-action-icon" (click)="openStudentProfileView(row)" title="{{ 'groupsV2.print' | translate }}">
                  <i class="ri-printer-line"></i>
                </span>
                <span class="gv2-action-icon" (click)="getStudentUpdateHistory(row)" title="{{ 'groupsV2.history' | translate }}">
                  <i class="ri-history-line"></i>
                </span>
              </td>
              <td class="gv2-action-cell" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isStudentSelected(row)"
                       (change)="toggleStudentSelection(row, $any($event.target).checked)" />
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Footer / pagination -->
      <p-paginator
        [rows]="pageSize"
        [first]="pageIndex * pageSize"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="pageSizeOptions"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="studentsPaginatorReportTemplate"
        (onPageChange)="onPaginatorChange($event)"
        styleClass="gv2-paginator">
      </p-paginator>
    </div>

    <!-- Staffs tab -->
    <div class="gv2-tab-content" *ngIf="activeTab === 'staff'">

      <!-- Filter row -->
      <div class="gv2-filter-row">
        <select class="gv2-pill-select" [ngModel]="staffFilterDesignation"
                (ngModelChange)="onStaffDesignationFilterChange($event)" [ngModelOptions]="{standalone: true}">
          <option value="all">{{ 'groupsV2.allStaffs' | translate }}</option>
          <option *ngFor="let designation of schoolDesignationList" [ngValue]="designation.designationId">
            {{ designation.designation }}
          </option>
        </select>

        <select class="gv2-pill-select" [ngModel]="staffFilterAppStatus"
                (ngModelChange)="onStaffStatusFilterChange($event)" [ngModelOptions]="{standalone: true}">
          <option value="all">{{ 'groupsV2.activeInactive' | translate }}</option>
          <option value="1">{{ 'groupsV2.active' | translate }}</option>
          <option value="0">{{ 'groupsV2.inactive' | translate }}</option>
        </select>

        <div class="gv2-export-group" *ngIf="permissions.SCHOOL_STAFFS_MANAGEMENT === 'ENABLED'">
          <button type="button" class="gv2-btn-outline"
                  [disabled]="exportingStaff || staffTotalRecords === 0" (click)="exportStaffToExcel()">
            <i class="ri-file-excel-2-line"></i> {{ (exportingStaff ? 'groupsV2.pleaseWait' : 'groupsV2.exportStaff') | translate }}
          </button>
        </div>
      </div>

      <!-- Selection floating bar -->
      <div class="gv2-selection-bar" *ngIf="selectedStaffIdsForPrint.length > 0" (click)="$event.stopPropagation()">
        <span>{{ 'groupsV2.staffsSelected' | translate: { count: selectedStaffIdsForPrint.length } }}</span>
        <div class="gv2-selection-actions">
          <button type="button" class="gv2-btn-outline" (click)="clearStaffSelection()">{{ 'groupsV2.clear' | translate }}</button>
          <button type="button" class="gv2-btn-gradient" *ngIf="staffIdCardServiceEnabled" (click)="openStaffIdCardBuilder()">{{ 'groupsV2.idCard' | translate }}</button>
        </div>
      </div>

      <!-- Table -->
      <div class="gv2-table-wrap">
        <table class="gv2-table">
          <thead>
            <tr>
              <th>{{ 'groupsV2.sNo' | translate }}</th>
              <th class="sortable" (click)="onStaffSortClick('staffName')">
                {{ 'groupsV2.staffName' | translate }}
                <i [ngClass]="staffSortColumn === 'staffName' ? (staffSortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th class="sortable" (click)="onStaffSortClick('employmentId')">
                {{ 'groupsV2.empId' | translate }}
                <i [ngClass]="staffSortColumn === 'employmentId' ? (staffSortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th class="sortable" (click)="onStaffSortClick('designation')">
                {{ 'groupsV2.designationCol' | translate }}
                <i [ngClass]="staffSortColumn === 'designation' ? (staffSortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line') : 'ri-arrow-up-down-line'"></i>
              </th>
              <th>{{ 'groupsV2.email' | translate }}</th>
              <th>{{ 'groupsV2.contactNumber' | translate }}</th>
              <th>{{ 'groupsV2.genderCol' | translate }}</th>
              <th>{{ 'groupsV2.appStatus' | translate }}</th>
              <th>
                {{ 'groupsV2.printId' | translate }}
                <input type="checkbox" [checked]="allStaffSelected" (change)="toggleSelectAllStaff($any($event.target).checked)" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of staffSkeletonRows" class="gv2-skeleton-row">
              <td *ngFor="let c of staffSkeletonColumns">
                <span class="gv2-skeleton-bar"></span>
              </td>
            </tr>
            <tr *ngIf="!loadingStaff && staff.length === 0">
              <td colspan="8" class="gv2-empty">{{ 'groupsV2.noStaffsFound' | translate }}</td>
            </tr>
            <ng-container *ngIf="!loadingStaff">
            <tr *ngFor="let row of staff; let i = index; trackBy: trackByStaffRowId"
                [class.gv2-row-clickable]="permissions.UPDATE_STAFF === 'ENABLED'"
                (click)="permissions.UPDATE_STAFF === 'ENABLED' && openStaffDetail(row)">
              <td>{{ staffPageIndex * staffPageSize + i + 1 }}</td>
              <td>
                <div class="gv2-student-cell">
                  <img class="gv2-student-avatar" *ngIf="row.staffImage && row.staffImage !== '/images/placeholder.png'"
                    [src]="row.staffImage" alt="" />
                  <span class="gv2-history-avatar" *ngIf="!row.staffImage || row.staffImage === '/images/placeholder.png'">{{ row.staffName?.charAt(0) }}</span>
                  <span>{{ row.staffName }}</span>
                </div>
              </td>
              <td>{{ row.employmentId }}</td>
              <td>{{ row.designation }}</td>
              <td>{{ row.emailId }}</td>
              <td>{{ row.mobileNumber }}</td>
              <td>{{ formatStaffColumnValue('gender', row) }}</td>
              <td><span class="gv2-badge">{{ formatStaffColumnValue('isAppUser', row) }}</span></td>
              <td class="gv2-action-cell" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isStaffSelected(row)"
                       (change)="toggleStaffSelection(row, $any($event.target).checked)" />
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Footer / pagination -->
      <p-paginator
        [rows]="staffPageSize"
        [first]="staffPageIndex * staffPageSize"
        [totalRecords]="staffTotalRecords"
        [rowsPerPageOptions]="pageSizeOptions"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="staffsPaginatorReportTemplate"
        (onPageChange)="onStaffPaginatorChange($event)"
        styleClass="gv2-paginator">
      </p-paginator>
    </div>
  </div>
</div>

<!-- View / Edit Staff - single popup mirroring groups.component.ts's
     view-offcanvas -> edit-offcanvas flow. Deactivate is the Account Status
     field here (with a required reason once "Inactive" is picked), matching
     groupsStaffUpdate()'s staffBlockStatus/reason params. -->
<p-dialog [(visible)]="openStaffPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeStaffPopup()">
  <div class="gv2-basicinfo-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-edit-2-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.updateStaff' | translate }}</h3>
          <p>{{ 'groupsV2.updateStaffHint' | translate }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="closeStaffPopup()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body">
      <div *ngIf="staffPopupLoading" class="gv2-basicinfo-skeleton">
        <span class="gv2-skeleton-bar" *ngFor="let r of [1,2,3,4,5,6]"></span>
      </div>

      <form *ngIf="!staffPopupLoading" class="gv2-basicinfo-form">
        <div class="gv2-basicinfo-photo-row">
          <div class="gv2-basicinfo-photo-col">
            <div class="gv2-basicinfo-photo-wrap">
              <div class="gv2-basicinfo-photo">
                <img *ngIf="staffPopupData.staffImage" [src]="staffPopupData.staffImage" alt="" />
                <i *ngIf="!staffPopupData.staffImage" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-staff-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-staff-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onStaffPhotoSelected($event)" />
            </div>
            <div class="gv2-basicinfo-photo-actions">
              <label for="gv2-staff-photo-input" class="gv2-btn-outline">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.update' | translate }}
              </label>
              <button type="button" class="gv2-btn-outline gv2-basicinfo-danger-outline"
                *ngIf="staffPopupData.staffImage" [disabled]="staffPopupUploadingPhoto"
                (click)="removeStaffPhoto()">
                <i class="ri-delete-bin-6-line"></i>
              </button>
            </div>
          </div>

          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.staffNameLabel' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.staffNamePlaceholder' | translate }}" [(ngModel)]="staffPopupData.staffName" name="staffName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.employeeId' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.empIdPlaceholder' | translate }}" [(ngModel)]="staffPopupData.empId" name="empId" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.designationLabel' | translate }}<span class="gv2-required">*</span></label>
              <select class="gv2-basicinfo-input" [(ngModel)]="staffPopupData.designationId" name="designationId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
                <option *ngFor="let d of schoolDesignationList" [ngValue]="d.designationId">{{ d.designation }}</option>
              </select>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.qualificationLabel' | translate }}<span class="gv2-required">*</span></label>
              <select class="gv2-basicinfo-input" [(ngModel)]="staffPopupData.qualificationId" name="qualificationId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.selectQualification' | translate }}</option>
                <option *ngFor="let q of staffQualificationList" [ngValue]="q.pkStaffQualificationId">{{ q.Qualification }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <div class="gv2-basicinfo-grid">
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.dateOfBirthLabel' | translate }}<span class="gv2-required">*</span></label>
            <p-calendar styleClass="gv2-calendar" [(ngModel)]="staffPopupDOBDate" [ngModelOptions]="{standalone: true}"
              dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" appendTo="body" (onSelect)="onStaffDOBSelect($event)"
              placeholder="{{ 'groupsV2.dateOfBirthPlaceholder' | translate }}"></p-calendar>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.dateOfJoiningLabel' | translate }}</label>
            <p-calendar styleClass="gv2-calendar" [(ngModel)]="staffPopupDOJDate" [ngModelOptions]="{standalone: true}"
              dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" appendTo="body" (onSelect)="onStaffDOJSelect($event)"
              placeholder="{{ 'groupsV2.dateOfJoiningPlaceholder' | translate }}"></p-calendar>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.mobileNumberLabel' | translate }}<span class="gv2-required">*</span></label>
            <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="invalidStaffPopupMobileNumber">
              <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                [ngModel]="staffPopupCountry" [ngModelOptions]="{standalone: true}"
                (countryChange)="onStaffPopupCountryChange($event)"></ngx-country-select>
              <input type="text" inputmode="numeric" id="gv2-staff-phone-input" [attr.maxlength]="staffPopupCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                [ngModel]="staffPopupData.mobileNumber" (ngModelChange)="onStaffPopupMobileNumberInput($event)"
                name="mobileNumber" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.genderLabel' | translate }}</label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.gender === 1">
                <input type="radio" name="staffGender" [value]="1" [(ngModel)]="staffPopupData.gender" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.male' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.gender === 0">
                <input type="radio" name="staffGender" [value]="0" [(ngModel)]="staffPopupData.gender" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.female' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.emailLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.emailPlaceholder' | translate }}" [(ngModel)]="staffPopupData.emailId" name="emailId" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ brand.nationalIdFieldLabelKey | translate }}</label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.aadharPlaceholder' | translate }}" maxlength="12" [(ngModel)]="staffPopupData.aadharNumber" name="aadharNumber" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ brand.nationalIdCopyLabelKey | translate }}</label>
            <div class="gv2-basicinfo-doc-row" *ngIf="staffPopupData.aadharCopy; else staffAadharUpload">
              <div class="gv2-basicinfo-doc-chip">
                <i class="ri-checkbox-circle-fill"></i>
                <a href="javascript:void(0)" (click)="previewBasicInfoDoc(staffPopupData.aadharCopy, staffAadharFileType, nationalIdCopyLabel)">{{ staffAadharFileType === 'application/pdf' ? 'AadharCopy.pdf' : 'AadharCopy' }}</a>
              </div>
              <label for="gv2-staff-aadhar-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ (staffPopupUploadingAadharCopy ? 'groupsV2.uploading' : 'groupsV2.change') | translate }}
              </label>
            </div>
            <ng-template #staffAadharUpload>
              <label for="gv2-staff-aadhar-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ (staffPopupUploadingAadharCopy ? 'groupsV2.uploading' : 'groupsV2.upload') | translate }}
              </label>
            </ng-template>
            <input id="gv2-staff-aadhar-input" type="file" accept="image/*,.pdf" style="display:none" (change)="onStaffAadharCopySelected($event)" />
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.addressLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.addressPlaceholder' | translate }}" [(ngModel)]="staffPopupData.address" name="address" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.bluewingsAppStatus' | translate:{ brandName: brand.name } }}</label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.isAppUser === 1">
                <input type="radio" name="staffAppStatus" [value]="1" [(ngModel)]="staffPopupData.isAppUser" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.connected' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.isAppUser === 0">
                <input type="radio" name="staffAppStatus" [value]="0" [(ngModel)]="staffPopupData.isAppUser" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.disconnected' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.accountStatus' | translate }}</label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.isBlocked === 0">
                <input type="radio" name="staffBlockStatus" [value]="0" [(ngModel)]="staffPopupData.isBlocked" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.active' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="staffPopupData.isBlocked === 1">
                <input type="radio" name="staffBlockStatus" [value]="1" [(ngModel)]="staffPopupData.isBlocked" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.inactive' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full" *ngIf="staffPopupData.isBlocked === 1">
            <label>{{ 'groupsV2.reason' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.deactivateReasonPlaceholder' | translate }}"
              [(ngModel)]="staffPopupData.reason" name="staffReason" [ngModelOptions]="{standalone: true}" />
          </div>
        </div>
      </form>
    </div>

    <div class="gv2-modal-footer" *ngIf="!staffPopupLoading">
      <button type="button" class="gv2-btn-outline" *ngIf="brand.enableSendStaffPassword" [disabled]="sendingStaffPassword"
        (click)="sendStaffPassword()">
        <span *ngIf="!sendingStaffPassword">{{ 'sendPassword' | translate }}</span>
        <span *ngIf="sendingStaffPassword" class="gv2-dochub-spinner"></span>
      </button>
      <button type="button" class="gv2-btn-outline" (click)="closeStaffPopup()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="staffPopupSaving" (click)="saveStaffDetail()">
        <span *ngIf="!staffPopupSaving">{{ 'groupsV2.save' | translate }}</span>
        <span *ngIf="staffPopupSaving" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
      </button>
    </div>
  </div>
</p-dialog>

<!-- Add Staff - native groups-v2 popup mirroring groups.component.ts's
     addNewStaffButton()/addNewStaffDetail() offcanvas form. -->
<p-dialog [(visible)]="openAddStaffPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeAddStaffPopup()">
  <div class="gv2-basicinfo-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-user-add-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.addStaffTitle' | translate }}</h3>
          <p>{{ 'groupsV2.addStaffHint' | translate }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="closeAddStaffPopup()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body">
      <form class="gv2-basicinfo-form">
        <div class="gv2-basicinfo-photo-row">
          <div class="gv2-basicinfo-photo-col">
            <div class="gv2-basicinfo-photo-wrap">
              <div class="gv2-basicinfo-photo">
                <img *ngIf="addStaffPhotoPreview" [src]="addStaffPhotoPreview" alt="" />
                <i *ngIf="!addStaffPhotoPreview" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-add-staff-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-add-staff-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onAddStaffPhotoSelected($event)" />
            </div>
            <div class="gv2-basicinfo-photo-actions">
              <label for="gv2-add-staff-photo-input" class="gv2-btn-outline">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.update' | translate }}
              </label>
              <button type="button" class="gv2-btn-outline gv2-basicinfo-danger-outline"
                *ngIf="addStaffPhotoPreview" (click)="removeAddStaffPhoto()">
                <i class="ri-delete-bin-6-line"></i>
              </button>
            </div>
          </div>

          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.staffNameLabel' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.staffNamePlaceholder' | translate }}" [(ngModel)]="addStaffData.staffName" name="addStaffName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.employeeId' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.empIdPlaceholder' | translate }}" [(ngModel)]="addStaffData.empId" name="addEmpId" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.designationLabel' | translate }}<span class="gv2-required">*</span></label>
              <select class="gv2-basicinfo-input" [(ngModel)]="addStaffData.designationId" name="addDesignationId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
                <option *ngFor="let d of schoolDesignationList" [ngValue]="d.designationId">{{ d.designation }}</option>
              </select>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.qualificationLabel' | translate }}<span class="gv2-required">*</span></label>
              <select class="gv2-basicinfo-input" [(ngModel)]="addStaffData.qualificationId" name="addQualificationId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.selectQualification' | translate }}</option>
                <option *ngFor="let q of staffQualificationList" [ngValue]="q.pkStaffQualificationId">{{ q.Qualification }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <div class="gv2-basicinfo-grid">
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.dateOfBirthLabel' | translate }}<span class="gv2-required">*</span></label>
            <p-calendar styleClass="gv2-calendar" [(ngModel)]="addStaffDOBDate" [ngModelOptions]="{standalone: true}"
              dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" appendTo="body" (onSelect)="onAddStaffDOBSelect($event)"
              placeholder="{{ 'groupsV2.dateOfBirthPlaceholder' | translate }}"></p-calendar>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.dateOfJoiningLabel' | translate }}</label>
            <p-calendar styleClass="gv2-calendar" [(ngModel)]="addStaffDOJDate" [ngModelOptions]="{standalone: true}"
              dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" appendTo="body" (onSelect)="onAddStaffDOJSelect($event)"
              placeholder="{{ 'groupsV2.dateOfJoiningPlaceholder' | translate }}"></p-calendar>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.mobileNumberLabel' | translate }}<span class="gv2-required">*</span></label>
            <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="invalidAddStaffMobileNumber">
              <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                [ngModel]="addStaffCountry" [ngModelOptions]="{standalone: true}"
                (countryChange)="onAddStaffCountryChange($event)"></ngx-country-select>
              <input type="text" inputmode="numeric" id="gv2-add-staff-phone-input" [attr.maxlength]="addStaffCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                [ngModel]="addStaffData.mobileNumber" (ngModelChange)="onAddStaffMobileNumberInput($event)"
                name="addMobileNumber" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.genderLabel' | translate }}</label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="addStaffData.gender === 1">
                <input type="radio" name="addGender" [value]="1" [(ngModel)]="addStaffData.gender" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.male' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="addStaffData.gender === 0">
                <input type="radio" name="addGender" [value]="0" [(ngModel)]="addStaffData.gender" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.female' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.emailLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.emailPlaceholder' | translate }}" [(ngModel)]="addStaffData.emailId" name="addEmailId" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ brand.nationalIdFieldLabelKey | translate }}</label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.aadharPlaceholder' | translate }}" maxlength="12" [(ngModel)]="addStaffData.aadharNumber" name="addAadharNumber" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ brand.nationalIdCopyLabelKey | translate }}</label>
            <div class="gv2-basicinfo-doc-row" *ngIf="addStaffAadharPreviewName; else addStaffAadharUpload">
              <div class="gv2-basicinfo-doc-chip">
                <i class="ri-checkbox-circle-fill"></i>
                <a href="javascript:void(0)" (click)="previewAddStaffAadharCopy()">{{ addStaffAadharPreviewName }}</a>
              </div>
              <label for="gv2-add-staff-aadhar-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.change' | translate }}
              </label>
            </div>
            <ng-template #addStaffAadharUpload>
              <label for="gv2-add-staff-aadhar-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
              </label>
            </ng-template>
            <input id="gv2-add-staff-aadhar-input" type="file" accept="image/*,.pdf" style="display:none" (change)="onAddStaffAadharCopySelected($event)" />
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.addressLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.addStaffAddressPlaceholder' | translate }}" [(ngModel)]="addStaffData.address" name="addAddress" [ngModelOptions]="{standalone: true}" />
          </div>
        </div>
      </form>
    </div>

    <div class="gv2-modal-footer">
      <button type="button" class="gv2-btn-outline" (click)="closeAddStaffPopup()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="addStaffSaving" (click)="submitAddStaff()">
        <span *ngIf="!addStaffSaving">{{ 'groupsV2.addStaffTitle' | translate }}</span>
        <span *ngIf="addStaffSaving" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
      </button>
    </div>
  </div>
</p-dialog>

<!-- Manage Designation - native groups-v2 popup mirroring groups.component.ts's
     #offcanvas-staff-desgnation (add/edit form + editable list). -->
<p-dialog [(visible)]="openManageDesignationPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-dochub-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeManageDesignationPopup()">
  <div class="gv2-dochub-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-award-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.manageDesignation' | translate }}</h3>
          <p>{{ 'groupsV2.manageDesignationHint' | translate }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="closeManageDesignationPopup()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-dochub-body">
      <div class="gv2-designation-form-card">
        <form class="gv2-basicinfo-form">
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.designationNameLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.designationNamePlaceholder' | translate }}" [(ngModel)]="designationForm.name" name="designationName" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label class="gv2-designation-access-label">{{ 'groupsV2.appAccessLevel' | translate }}</label>
            <div class="gv2-designation-access-row">
              <label class="gv2-designation-chip" [class.active]="designationForm.isSuperAdmin">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" [(ngModel)]="designationForm.isSuperAdmin" [ngModelOptions]="{standalone: true}" name="isSuperAdmin" />
                {{ 'groupsV2.superAdmin' | translate }}
              </label>
              <label class="gv2-designation-chip" [class.active]="designationForm.isFinanceAdmin">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" [(ngModel)]="designationForm.isFinanceAdmin" [ngModelOptions]="{standalone: true}" name="isFinanceAdmin" />
                {{ 'groupsV2.financeAdmin' | translate }}
              </label>
              <label class="gv2-designation-chip" [class.active]="designationForm.isFeeDefaulterAdmin">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" [(ngModel)]="designationForm.isFeeDefaulterAdmin" [ngModelOptions]="{standalone: true}" name="isFeeDefaulterAdmin" />
                {{ 'groupsV2.feeDefaulterManager' | translate }}
              </label>
              <label class="gv2-designation-chip" [class.active]="designationForm.isClassTeacher">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" [(ngModel)]="designationForm.isClassTeacher" [ngModelOptions]="{standalone: true}" name="isClassTeacher" />
                {{ 'groupsV2.classTeacher' | translate }}
              </label>
              <label class="gv2-designation-chip" [class.active]="designationForm.isDriver">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" [(ngModel)]="designationForm.isDriver" [ngModelOptions]="{standalone: true}" name="isDriver" />
                {{ 'groupsV2.driver' | translate }}
              </label>
              <label class="gv2-designation-chip active" style="cursor: default;" title="{{ 'groupsV2.defaultAccessHint' | translate }}">
                <span class="gv2-designation-checkbox"><i class="ri-check-line"></i></span>
                <input type="checkbox" checked disabled />
                {{ 'groupsV2.defaultTag' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full gv2-designation-form-actions">
            <button type="button" class="gv2-btn-outline" *ngIf="designationEditingId" [disabled]="designationSaving" (click)="cancelEditDesignationRow()">{{ 'groupsV2.cancel' | translate }}</button>
            <button type="button" class="gv2-btn-gradient" [disabled]="designationSaving" (click)="submitDesignationForm()">
              <ng-container *ngIf="!designationSaving">
                <i class="ri-add-line"></i> {{ (designationEditingId ? 'groupsV2.update' : 'groupsV2.addDesignation') | translate }}
              </ng-container>
              <span *ngIf="designationSaving" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
            </button>
          </div>
        </form>
      </div>

      <div class="gv2-designation-list-header">
        <h4>{{ 'groupsV2.existingDesignations' | translate }}</h4>
        <span class="gv2-designation-count-badge">{{ schoolDesignationList.length }}</span>
      </div>

      <div class="gv2-dochub-list">
        <div class="gv2-dochub-list-item" *ngFor="let designation of schoolDesignationList">
          <div class="gv2-dochub-list-item-main">
            <strong>{{ designation.designation }}</strong>
            <div class="gv2-designation-tags">
              <span class="gv2-designation-tag gv2-designation-tag-default">{{ 'groupsV2.defaultTag' | translate }}</span>
              <span class="gv2-designation-tag" *ngIf="designation.isSuperAdmin">{{ 'groupsV2.superAdmin' | translate }}</span>
              <span class="gv2-designation-tag" *ngIf="designation.isFinanceAdmin">{{ 'groupsV2.financeAdmin' | translate }}</span>
              <span class="gv2-designation-tag" *ngIf="designation.isFeeDefaulterAdmin">{{ 'groupsV2.feeDefaulterManager' | translate }}</span>
              <span class="gv2-designation-tag" *ngIf="designation.isClassTeacher">{{ 'groupsV2.classTeacher' | translate }}</span>
              <span class="gv2-designation-tag" *ngIf="designation.isDriver">{{ 'groupsV2.driver' | translate }}</span>
            </div>
          </div>
          <span class="gv2-designation-edit-btn" (click)="editDesignationRow(designation)"><i class="ri-edit-line"></i></span>
        </div>
        <div class="gv2-dochub-state gv2-dochub-empty" *ngIf="schoolDesignationList.length === 0">{{ 'groupsV2.noDesignationsYet' | translate }}</div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Manage Qualification - native groups-v2 popup mirroring groups.component.ts's
     #offcanvas-staff-qualification (add/edit form + editable list). -->
<p-dialog [(visible)]="openManageQualificationPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-dochub-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeManageQualificationPopup()">
  <div class="gv2-dochub-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-graduation-cap-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.manageQualification' | translate }}</h3>
          <p>{{ 'groupsV2.manageQualificationHint' | translate }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="closeManageQualificationPopup()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-dochub-body">
      <form class="gv2-basicinfo-form">
        <div class="gv2-basicinfo-field gv2-basicinfo-field-full gv2-designation-form-actions">
          <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.qualificationNamePlaceholder' | translate }}"
            [(ngModel)]="qualificationName" name="qualificationName" [ngModelOptions]="{standalone: true}" />
          <button type="button" class="gv2-btn-outline" *ngIf="qualificationEditingId" [disabled]="qualificationSaving" (click)="cancelEditQualificationRow()">{{ 'groupsV2.cancel' | translate }}</button>
          <button type="button" class="gv2-btn-gradient" [disabled]="qualificationSaving" (click)="submitQualificationForm()">
            <span *ngIf="!qualificationSaving">{{ (qualificationEditingId ? 'groupsV2.update' : 'groupsV2.add') | translate }}</span>
            <span *ngIf="qualificationSaving" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
          </button>
        </div>
      </form>

      <div class="gv2-dochub-divider"></div>

      <div class="gv2-dochub-list">
        <div class="gv2-dochub-list-item" *ngFor="let qualification of staffQualificationList">
          <div class="gv2-dochub-list-item-main">
            <strong>{{ qualification.Qualification }}</strong>
          </div>
          <span class="gv2-action-icon" (click)="editQualificationRow(qualification)"><i class="ri-edit-line"></i></span>
        </div>
        <div class="gv2-dochub-state gv2-dochub-empty" *ngIf="!qualificationLoading && staffQualificationList.length === 0">{{ 'groupsV2.noQualificationsYet' | translate }}</div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Update Roll Number - native groups-v2 replacement for the legacy
     #update-roll-number-popup bulk roll-number editor (groups.component.html).
     Same visual pattern as Document Hub (gv2-basicinfo-header / gv2-dochub-*
     table/search/state classes) for UI consistency with the other popups. -->
<p-dialog [(visible)]="showUpdateRollNumberPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-dochub-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeUpdateRollNumberPopup()">
  <div class="gv2-dochub-modal" (click)="sortRollNumberMenuOpen = false">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-sort-number-asc"></i></div>
        <div>
          <h3>{{ 'groupsV2.updateRollNumber' | translate }}</h3>
          <p>{{ updateRollNumberClassName }}<ng-container *ngIf="updateRollNumberSectionName"> &middot;
              {{ updateRollNumberSectionName }}</ng-container> &middot;
            {{ updateRollNumberStudentList.length }} {{ 'groupsV2.students' | translate }}</p>
        </div>
      </div>
      <div class="gv2-dochub-header-right">
        <div class="gv2-dochub-search" *ngIf="!updateRollNumberLoading && updateRollNumberStudentList.length > 0">
          <i class="ri-search-line"></i>
          <input type="text" placeholder="{{ 'groupsV2.searchByNameAdmissionNoOrMobile' | translate }}"
            [(ngModel)]="rollNumberSearchText" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="filterRollNumberStudentList()" />
        </div>
        <div class="gv2-column-dropdown" *ngIf="!updateRollNumberLoading && updateRollNumberStudentList.length > 0"
          (click)="$event.stopPropagation()">
          <button type="button" class="gv2-btn-outline" [disabled]="savingRollNumbers" (click)="toggleSortRollNumberMenu()">
            <i class="ri-sort-alphabet-asc"></i> {{ 'groupsV2.updateRollNumberByDropdown' | translate }} <i class="ri-arrow-down-s-line"></i>
          </button>
          <ul class="gv2-column-menu" *ngIf="sortRollNumberMenuOpen">
            <li (click)="sortRollNumbersBy('name')">{{ 'groupsV2.alphabeticalOrder' | translate }}</li>
            <li (click)="sortRollNumbersBy('admissionNumber')">{{ 'groupsV2.byAdmissionNumber' | translate }}</li>
          </ul>
        </div>
        <button type="button" class="gv2-basicinfo-close-btn" (click)="closeUpdateRollNumberPopup()">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </div>

    <div class="gv2-dochub-body gv2-dochub-body-list">
      <div class="gv2-dochub-table-wrap">
        <div *ngIf="updateRollNumberLoading" class="gv2-dochub-state">
          <span class="gv2-dochub-spinner"></span> {{ 'groupsV2.loadingEllipsis' | translate }}
        </div>

        <div *ngIf="!updateRollNumberLoading && filteredRollNumberStudentList.length === 0" class="gv2-dochub-state gv2-dochub-empty">
          <i class="ri-user-search-line"></i>
          <p>{{ 'groupsV2.noStudentsAvailable' | translate }}</p>
        </div>

        <table class="gv2-dochub-table" *ngIf="!updateRollNumberLoading && filteredRollNumberStudentList.length > 0">
          <thead>
            <tr>
              <th>{{ 'groupsV2.student' | translate }}</th>
              <th>{{ 'groupsV2.admission' | translate }}</th>
              <th>{{ 'groupsV2.roll' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let student of filteredRollNumberStudentList">
              <td>
                <div class="gv2-student-cell">
                  <img class="gv2-student-avatar"
                    [src]="student.studentImage || 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png'"
                    alt="" />
                  <div>
                    <div>{{ student.studentName }}</div>
                    <div class="gv2-dochub-desc">{{ 'groupsV2.fathersName' | translate }}: {{ student.fatherName }} &middot; {{ student.mobileNumber }}</div>
                  </div>
                </div>
              </td>
              <td>{{ student.admissionNumber }}</td>
              <td>
                <input type="text" class="gv2-basicinfo-input" style="width:80px;text-align:center;"
                  [class.gv2-basicinfo-input-error]="!student.rollNumber" [(ngModel)]="student.rollNumber"
                  [ngModelOptions]="{standalone: true}" (keydown)="handleKeyDown($event)"
                  (paste)="sanitizeRollNumberOnPaste($event, student)" maxlength="4" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="gv2-dochub-footer gv2-dochub-footer-split gv2-rollnumber-footer">
      <div class="gv2-dochub-desc" [style.color]="hasEmptyRollNumber() ? '#E32C2C' : null">
        <i class="ri-error-warning-line" *ngIf="hasEmptyRollNumber()"></i>
        <i class="ri-information-line" *ngIf="!hasEmptyRollNumber()"></i>
        {{ (hasEmptyRollNumber() ? 'groupsV2.rollNumberCannotBeEmpty' : 'groupsV2.tapRollNumberToEdit') | translate }}
      </div>
      <div style="display:flex;gap:10px;">
        <button type="button" class="gv2-btn-outline" [disabled]="savingRollNumbers" (click)="closeUpdateRollNumberPopup()">{{ 'groupsV2.cancel' | translate }}</button>
        <button type="button" class="gv2-btn-gradient" [disabled]="savingRollNumbers || hasEmptyRollNumber()" (click)="saveRollNumbers()">
          <span *ngIf="!savingRollNumbers">{{ 'groupsV2.saveChanges' | translate }}</span>
          <span *ngIf="savingRollNumbers" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Deactivate Student - native groups-v2 replacement for the shared
     <app-student-deactivate> component. Same visual pattern as the other
     ported popups (gv2-basicinfo-* classes). -->
<p-dialog [(visible)]="openStudentDeactivatePopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="studentDeactivatePopupClose()">
  <div class="gv2-basicinfo-modal gv2-deactivate-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon gv2-deactivate-header-icon"><i class="ri-user-unfollow-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.deactivateStudentTitle' | translate }}</h3>
          <p>{{ studentDeactivatePopupStudentName }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="studentDeactivatePopupClose()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body" *ngIf="!deactivateShowConfirm">
      <div class="gv2-basicinfo-field">
        <label>{{ 'groupsV2.selectReason' | translate }}<span class="gv2-required">*</span></label>
        <div class="gv2-dochub-select-wrap">
          <select class="gv2-basicinfo-input" [disabled]="deactivateReasonsLoading" [(ngModel)]="deactivateSelectedReasonId"
            name="deactivateReason" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">{{ 'groupsV2.noneSelected' | translate }}</option>
            <optgroup *ngFor="let group of deactivateReasonGroups" [label]="group.description">
              <option *ngFor="let reason of group.reasons" [ngValue]="reason.pkDeactivateReasonId">
                {{ reason.reason }} {{ (reason.deactivateWithCollectedFee === 'YES' ? 'groupsV2.deactivateWithFees' : 'groupsV2.deactivateWithoutFees') | translate }}
              </option>
            </optgroup>
          </select>
          <span *ngIf="deactivateReasonsLoading" class="gv2-dochub-spinner gv2-dochub-select-spinner"></span>
        </div>
      </div>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body" *ngIf="deactivateShowConfirm">
      <div class="gv2-deactivate-warning">
        <i class="ri-error-warning-line"></i>
        <p>{{ 'groupsV2.confirmDeactivateText' | translate: { name: studentDeactivatePopupStudentName } }}</p>
      </div>
    </div>

    <div class="gv2-modal-footer" *ngIf="!deactivateShowConfirm">
      <button type="button" class="gv2-btn-outline" (click)="studentDeactivatePopupClose()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient gv2-deactivate-btn" [disabled]="deactivateReasonsLoading" (click)="confirmDeactivateStudent()">
        <i class="ri-user-unfollow-line"></i> {{ 'groupsV2.deactivateBtn' | translate }}
      </button>
    </div>

    <div class="gv2-modal-footer" *ngIf="deactivateShowConfirm">
      <button type="button" class="gv2-btn-outline" [disabled]="deactivateProcessing" (click)="deactivateShowConfirm = false">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient gv2-deactivate-btn" [disabled]="deactivateProcessing" (click)="deactivateStudent()">
        <i class="ri-user-unfollow-line"></i> {{ (deactivateProcessing ? 'groupsV2.deactivating' : 'groupsV2.yesDeactivate') | translate }}
      </button>
    </div>
  </div>
</p-dialog>

<!-- Import Student - native groups-v2 replacement for the legacy inline
     jQuery bulk-upload flow (#bulkUploadSTudent + #import-student-canvas
     in groups.component.html). Same visual pattern as Document Hub. -->
<p-dialog [(visible)]="openImportStudentPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-dochub-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeImportStudentPopup()">
  <div class="gv2-dochub-modal gv2-import-student-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-upload-2-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.importStudentTitle' | translate }}</h3>
          <p *ngIf="importStudentStep === 'upload'">{{ 'groupsV2.importStudentBulkUploadHint' | translate }}</p>
          <p *ngIf="importStudentStep === 'results'">{{ 'groupsV2.importStudentVerifyHint' | translate }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="closeImportStudentPopup()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <!-- Step 1: class/section pickers + file upload -->
    <div class="gv2-dochub-body" *ngIf="importStudentStep === 'upload'">
      <div class="gv2-import-student-hint">
        <p>{{ 'groupsV2.importStudentHint1' | translate }}</p>
        <p>{{ 'groupsV2.importStudentHint2' | translate }}</p>
        <p>{{ 'groupsV2.importStudentHint3' | translate }}</p>
        <p>{{ 'groupsV2.importStudentHint4' | translate }}</p>
        <p>{{ 'groupsV2.importStudentHint5' | translate }}</p>
        <p>{{ 'groupsV2.importStudentHint6Prefix' | translate }} <a href="https://bluewingsfilestorage.s3.us-west-2.amazonaws.com/BluewingsEnterprise/student_bulk_upload_template_latest.xlsx" target="_blank" download="student_bulk_upload_template_sheet.xls">{{ 'groupsV2.importStudentHint6Link' | translate }}</a>.</p>
      </div>

      <div class="gv2-basicinfo-grid">
        <div class="gv2-basicinfo-field">
          <label>{{ 'groupsV2.category' | translate }}<span class="gv2-required">*</span></label>
          <select class="gv2-basicinfo-input" [(ngModel)]="importStudentSelectedCategory" name="importCategory"
            [ngModelOptions]="{standalone: true}" (change)="onImportStudentCategoryChange()">
            <option [ngValue]="null">{{ 'groupsV2.selectCategory' | translate }}</option>
            <option *ngFor="let category of importStudentCategoryList" [ngValue]="category.categoryId">{{ category.categoryName }}</option>
          </select>
        </div>
        <div class="gv2-basicinfo-field">
          <label>{{ 'groupsV2.class' | translate }}<span class="gv2-required">*</span></label>
          <select class="gv2-basicinfo-input" [(ngModel)]="importStudentSelectedClass" name="importClass"
            [ngModelOptions]="{standalone: true}" (change)="onImportStudentClassChange()" [disabled]="!importStudentSelectedCategory">
            <option [ngValue]="null">{{ 'groupsV2.selectClassLowercase' | translate }}</option>
            <option *ngFor="let cls of importStudentClassList" [ngValue]="cls.classid">{{ cls.classname }}</option>
          </select>
        </div>
        <div class="gv2-basicinfo-field">
          <label>{{ 'groupsV2.section' | translate }}<span class="gv2-required">*</span></label>
          <select class="gv2-basicinfo-input" [(ngModel)]="importStudentSelectedSection" name="importSection"
            [ngModelOptions]="{standalone: true}" [disabled]="!importStudentSelectedClass">
            <option [ngValue]="null">{{ 'groupsV2.selectSection' | translate }}</option>
            <option *ngFor="let section of importStudentSectionList" [ngValue]="section.claaSectionId">{{ section.classSection }}</option>
          </select>
        </div>
        <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
          <label>{{ 'groupsV2.file' | translate }}<span class="gv2-required">*</span></label>
          <label for="gv2-import-student-file-input" class="gv2-import-student-dropzone"
            [class.gv2-import-student-dropzone-active]="importStudentDragOver"
            [class.gv2-import-student-dropzone-filled]="importStudentSelectedFile"
            (dragover)="onImportStudentDragOver($event)" (dragleave)="onImportStudentDragLeave($event)"
            (drop)="onImportStudentDrop($event)">
            <i class="ri-upload-cloud-2-line"></i>
            <ng-container *ngIf="importStudentSelectedFile; else importStudentDropHint">
              {{ importStudentSelectedFile.name }}
            </ng-container>
            <ng-template #importStudentDropHint>
              <span>{{ 'groupsV2.importStudentDropHint' | translate }} <span class="gv2-import-student-browse-link">{{ 'groupsV2.browse' | translate }}</span></span>
            </ng-template>
          </label>
          <input id="gv2-import-student-file-input" type="file" accept=".xls,.xlsx" style="display:none" (change)="onImportStudentFileSelected($event)" />
        </div>
      </div>
    </div>

    <!-- Step 2: parsed rows with per-cell error highlighting -->
    <div class="gv2-dochub-body gv2-dochub-body-list" *ngIf="importStudentStep === 'results'">
      <div class="gv2-dochub-table-wrap">
        <table class="gv2-dochub-table gv2-import-student-table" *ngIf="importStudentRows.length > 0">
          <thead>
            <tr>
              <th *ngFor="let col of importStudentColumns">{{ col.labelKey | translate }}</th>
              <th class="gv2-dochub-actions-head"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of importStudentRows; let i = index">
              <td *ngFor="let col of importStudentColumns" [class.gv2-import-student-error]="row[col.statusKey] == '1' && !row.editing">
                <ng-container *ngIf="!row.editing">{{ row[col.key] }}</ng-container>
                <select *ngIf="row.editing && col.type === 'gender'" class="gv2-basicinfo-input" [(ngModel)]="row[col.key]" [ngModelOptions]="{standalone: true}">
                  <option value="M">M</option>
                  <option value="F">F</option>
                </select>
                <input *ngIf="row.editing && col.type === 'numeric'" type="text" inputmode="numeric" class="gv2-basicinfo-input"
                  [(ngModel)]="row[col.key]" [ngModelOptions]="{standalone: true}" (keydown)="handleKeyDown($event)" />
                <input *ngIf="row.editing && col.type !== 'gender' && col.type !== 'numeric'" type="text" class="gv2-basicinfo-input" [(ngModel)]="row[col.key]" [ngModelOptions]="{standalone: true}" />
              </td>
              <td class="gv2-dochub-actions-cell">
                <i class="ri-pencil-line" *ngIf="!row.editing" title="{{ 'groupsV2.editRow' | translate }}" (click)="row.editing = true"></i>
                <i class="ri-check-line" *ngIf="row.editing" title="{{ 'groupsV2.doneEditing' | translate }}" (click)="finishEditingImportStudentRow(row)"></i>
                <i class="ri-delete-bin-6-line gv2-dochub-danger" title="{{ 'groupsV2.deleteRow' | translate }}" (click)="deleteImportStudentRow(i)"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="importStudentRows.length === 0" class="gv2-dochub-state gv2-dochub-empty">
          <i class="ri-file-list-3-line"></i>
          <p>{{ 'groupsV2.importStudentNoRows' | translate }}</p>
        </div>
      </div>
      <div class="gv2-import-student-resolve">
        <p>{{ 'groupsV2.importStudentResolveHint' | translate }}</p>
      </div>
    </div>

    <div class="gv2-modal-footer" *ngIf="importStudentStep === 'upload'">
      <button type="button" class="gv2-btn-outline" (click)="closeImportStudentPopup()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="importStudentUploading" (click)="importStudentProceed()">
        <span *ngIf="!importStudentUploading">{{ 'groupsV2.import' | translate }}</span>
        <span *ngIf="importStudentUploading" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
      </button>
    </div>

    <div class="gv2-modal-footer" *ngIf="importStudentStep === 'results'">
      <button type="button" class="gv2-btn-outline" *ngIf="importStudentHasErrors" (click)="resolveImportStudentErrors()">{{ 'groupsV2.resolveErrors' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" *ngIf="importStudentIsEditing" (click)="resolveImportStudentProceedData()">{{ 'groupsV2.proceedData' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="importStudentCommitting" *ngIf="!importStudentHasErrors && !importStudentIsEditing"
        (click)="validateImportStudentByDuplicate()">
        <span *ngIf="!importStudentCommitting">{{ 'groupsV2.proceedData' | translate }}</span>
        <span *ngIf="importStudentCommitting" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
      </button>
    </div>
  </div>
</p-dialog>

<!-- Transport Options - native groups-v2 replacement for the shared
     <app-student-transport-settings-popup> component. Same visual pattern
     as Update Basic Info / Contact Details (gv2-basicinfo-* classes). -->
<p-dialog [(visible)]="openStudentTransportOptionSettingsPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="transportOptionsPopupClose()">
  <div class="gv2-basicinfo-modal gv2-transportoptions-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-bus-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.transportOptionsTitle' | translate }}</h3>
          <p>{{ studentTransportOptionsStudentName }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="transportOptionsPopupClose()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body">
      <div *ngIf="transportOptionsLoading && transportOptionsTerms.length === 0" class="gv2-basicinfo-skeleton">
        <span class="gv2-skeleton-bar" *ngFor="let r of [1,2,3,4]"></span>
      </div>

      <form *ngIf="transportOptionsTerms.length > 0 || !transportOptionsLoading" class="gv2-basicinfo-form">
        <div class="gv2-basicinfo-grid gv2-transportoptions-grid">
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.selectStop' | translate }}</label>
            <select class="gv2-basicinfo-input" [(ngModel)]="transportOptionsSelectedStopId" name="transportStop"
              [ngModelOptions]="{standalone: true}" (change)="onTransportOptionsStopChange()">
              <option [ngValue]="null">{{ 'groupsV2.notAssigned' | translate }}</option>
              <option *ngFor="let stop of transportOptionsStopList" [ngValue]="stop.PkBusStopId">{{ stop.BusStopName }} ({{ stop.fare }} {{ schoolCurrency }})</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.selectBus' | translate }}</label>
            <select class="gv2-basicinfo-input" [(ngModel)]="transportOptionsSelectedBusId" name="transportBus" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">{{ 'groupsV2.notAssigned' | translate }}</option>
              <option *ngFor="let b of transportOptionsBusList" [ngValue]="b.pkBusId">{{ b.BusName }}-{{ b.BusNumber }}-{{ b.RouteName }} ({{ b.startStop }} to {{ b.endStop }}) - (Capacity-{{ b.Capacity }}) - (Filled-{{ b.assignedStudents }})</option>
            </select>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.selectTerms' | translate }}
        </div>
        <div class="gv2-transportoptions-terms" *ngIf="transportOptionsTerms.length > 0; else gv2NoTransportTerms">
          <label class="gv2-basicinfo-checkbox">
            <input type="checkbox" [checked]="transportOptionsSelectAll" (change)="onTransportOptionsSelectAllChange($event.target.checked)" />
            {{ 'groupsV2.selectAllTerms' | translate }}
          </label>
          <label class="gv2-basicinfo-checkbox" *ngFor="let term of transportOptionsTerms">
            <input type="checkbox" [checked]="term.isSelectedTerm" [disabled]="!term.isEditable"
              (change)="onTransportOptionsTermChange(term, $event.target.checked)" />
            {{ term.termName }} ({{ 'groupsV2.dueDateLabel' | translate }}: {{ term.termDueDate | date }})
          </label>
        </div>
        <ng-template #gv2NoTransportTerms>
          <p class="gv2-transportoptions-empty">{{ 'groupsV2.noTransportTerms' | translate }}</p>
        </ng-template>
      </form>
    </div>

    <div class="gv2-modal-footer">
      <button type="button" class="gv2-btn-outline" (click)="transportOptionsPopupClose()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient gv2-basicinfo-save-btn" [disabled]="transportOptionsSaving || transportOptionsLoading" (click)="saveTransportOptions()">
        <i class="ri-save-3-line"></i> {{ (transportOptionsSaving ? 'groupsV2.saving' : 'groupsV2.saveChanges') | translate }}
      </button>
    </div>
  </div>
</p-dialog>

<!-- Update Basic Info - native groups-v2 popup replacing the shared
     app-student-basic-info component (see saveBasicInfo()/openBasicInfo()
     comments in groups-v2.component.ts for why + what's reused as-is). -->
<p-dialog [(visible)]="openStudentBasicInfoPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="studentBasicInfoPopupClose()">
  <div class="gv2-basicinfo-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-edit-2-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.updateBasicInfoTitle' | translate }}</h3>
          <p>{{ studentBasicInfoStudentName }} &middot; {{ basicInfoRegistrationId }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="studentBasicInfoPopupClose()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body">
      <!-- Skeleton loader while fetching student details -->
      <div *ngIf="basicInfoLoading && !basicInfoData.studentId" class="gv2-basicinfo-skeleton">
        <span class="gv2-skeleton-bar" *ngFor="let r of basicInfoSkeletonRows"></span>
      </div>

      <form *ngIf="!basicInfoShowClassChangeWarning && (basicInfoData.studentId || !basicInfoLoading)" class="gv2-basicinfo-form">
        <!-- Photo + Name/Surname/Email/Contact -->
        <div class="gv2-basicinfo-photo-row">
          <div class="gv2-basicinfo-photo-col">
            <div class="gv2-basicinfo-photo-wrap">
              <div class="gv2-basicinfo-photo">
                <img *ngIf="basicInfoData.studentImage" [src]="basicInfoData.studentImage" alt="" />
                <i *ngIf="!basicInfoData.studentImage" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-basicinfo-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-basicinfo-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onBasicInfoProfilePicSelected($event)" />
            </div>
            <div class="gv2-basicinfo-photo-actions">
              <label for="gv2-basicinfo-photo-input" class="gv2-btn-outline">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.update' | translate }}
              </label>
              <button type="button" class="gv2-btn-outline gv2-basicinfo-danger-outline"
                *ngIf="basicInfoData.studentImage" [disabled]="basicInfoRemovingPic"
                (click)="removeBasicInfoProfilePic()">
                <i class="ri-delete-bin-6-line"></i>
              </button>
            </div>
          </div>

          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.nameLabel' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.studentName" name="studentName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.surnameLabel' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.surname" name="surname" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.studentEmailLabel' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.studentEmail" name="studentEmail" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.studentContactLabel' | translate }}</label>
              <div class="gv2-basicinfo-phone-input" [class.gv2-basicinfo-input-error]="basicInfoInvalidMobileNumber">
                <input type="text" id="gv2-basicinfo-phone-input" maxlength="20" placeholder="{{ 'groupsV2.enterContactNumber' | translate }}"
                  [ngModel]="basicInfoSelectedContact" (ngModelChange)="onBasicInfoContactInput($event)"
                  name="studentContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <!-- Admission & Class -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.admissionAndClass' | translate }}
        </div>
        <div class="gv2-basicinfo-grid">
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.admissionDateLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.ddmmyyyy' | translate }}"
              [(ngModel)]="basicInfoData.dateOfAdmission" name="dateOfAdmission" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.admissionNumberLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.registrationId" name="registrationId" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.dateOfBirthBasicLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.ddmmyyyy' | translate }}"
              [(ngModel)]="basicInfoData.dateOfBirth" name="dateOfBirth" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.genderLabel' | translate }}<span class="gv2-required">*</span></label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="basicInfoData.gender === 1">
                <input type="radio" name="gender" [value]="1" [(ngModel)]="basicInfoData.gender"
                  [ngModelOptions]="{standalone: true}" (change)="onBasicInfoGenderChange()" />
                {{ 'groupsV2.male' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="basicInfoData.gender === 0">
                <input type="radio" name="gender" [value]="0" [(ngModel)]="basicInfoData.gender"
                  [ngModelOptions]="{standalone: true}" (change)="onBasicInfoGenderChange()" />
                {{ 'groupsV2.female' | translate }}
              </label>
            </div>
          </div>

          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.categoryLabel' | translate }}<span class="gv2-required">*</span></label>
            <select class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.categoryId" name="categoryId"
              [ngModelOptions]="{standalone: true}" (change)="onBasicInfoCategoryChange()">
              <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
              <option *ngFor="let category of basicInfoCategoryList" [ngValue]="category.categoryId">{{ category.categoryName }}</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.classLabel' | translate }}<span class="gv2-required">*</span></label>
            <select class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.fkClassStandardsId" name="classStandardId"
              [ngModelOptions]="{standalone: true}" (change)="onBasicInfoClassChange()">
              <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
              <option *ngFor="let standard of basicInfoClassStandardsList" [ngValue]="standard.pkClassStandardsId">{{ standard.ClassStandard }}</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.sectionLabel' | translate }}<span class="gv2-required">*</span></label>
            <select class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.classId" name="classId"
              [ngModelOptions]="{standalone: true}" (change)="onBasicInfoSectionChange()">
              <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
              <option *ngFor="let section of basicInfoSectionList" [ngValue]="section.classId">{{ section.classNumber }} - {{ section.classDivision }}</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.rollNumberLabel' | translate }}<span class="gv2-required">*</span></label>
            <input type="text" class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.rollNumber" name="rollNumber" [ngModelOptions]="{standalone: true}" />
          </div>

          <div class="gv2-basicinfo-field" *ngIf="basicInfoHouseNameList.length > 0">
            <label>{{ 'groupsV2.houseNameLabel' | translate }}</label>
            <select class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.houseName" name="houseName" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">{{ 'groupsV2.none' | translate }}</option>
              <option *ngFor="let house of basicInfoHouseNameList" [ngValue]="house.houseName">{{ house.houseName }}</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.admittedClassAcademic' | translate }}</label>
            <input type="text" class="gv2-basicinfo-input gv2-basicinfo-input-readonly" [ngModel]="basicInfoAdmittedClassYear" [ngModelOptions]="{standalone: true}" disabled />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.penNumber' | translate }}</label>
            <input type="text" class="gv2-basicinfo-input" maxlength="12" [(ngModel)]="basicInfoData.penNumber" name="penNumber" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ brand.nationalIdFieldLabelKey | translate }}</label>
            <input type="text" class="gv2-basicinfo-input" maxlength="12" [(ngModel)]="basicInfoData.aadharNumber" name="aadharNumber" [ngModelOptions]="{standalone: true}" />
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <!-- Documents & Category -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.documentsAndCategory' | translate }}
        </div>
        <div class="gv2-basicinfo-grid">
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.tcOrBirthCertSubmitted' | translate }}</label>
            <div class="gv2-basicinfo-pill-group">
              <label class="gv2-basicinfo-pill" [class.active]="basicInfoData.tcOrBirthCertificateUploaded === 1">
                <input type="radio" name="tcOrBirthCertificateUploaded" [value]="1"
                  [(ngModel)]="basicInfoData.tcOrBirthCertificateUploaded" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.yes' | translate }}
              </label>
              <label class="gv2-basicinfo-pill" [class.active]="basicInfoData.tcOrBirthCertificateUploaded === 0">
                <input type="radio" name="tcOrBirthCertificateUploaded" [value]="0"
                  [(ngModel)]="basicInfoData.tcOrBirthCertificateUploaded" [ngModelOptions]="{standalone: true}" />
                {{ 'groupsV2.no' | translate }}
              </label>
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.tcOrBirthCert' | translate }}</label>
            <ng-container *ngIf="basicInfoData.tcOrBirthCertificate; else tcUpload">
              <div class="gv2-basicinfo-doc-chip">
                <i class="ri-checkbox-circle-fill"></i>
                <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.tcOrBirthCertificate, basicInfoTcOrBirthCertFileType, 'TC/Birth Certificate')">{{ basicInfoTcOrBirthCertFileType === 'application/pdf' ? 'Certificate.pdf' : 'Certificate' }}</a>
              </div>
            </ng-container>
            <ng-template #tcUpload>
              <label for="gv2-basicinfo-tc-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
              </label>
            </ng-template>
            <input id="gv2-basicinfo-tc-input" type="file" style="display:none" (change)="onBasicInfoTcBirthCertSelected($event)" />
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.casteCategory' | translate }}</label>
            <select class="gv2-basicinfo-input" [(ngModel)]="basicInfoData.cast" name="cast"
              [ngModelOptions]="{standalone: true}" (change)="onBasicInfoCasteChange()">
              <option value="General">General</option>
              <option value="OBC">OBC</option>
              <option value="ST">ST</option>
              <option value="SC">SC</option>
            </select>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.casteCertificate' | translate }}</label>
            <ng-container *ngIf="basicInfoData.casteCertificate; else casteUpload">
              <div class="gv2-basicinfo-doc-chip">
                <i class="ri-checkbox-circle-fill"></i>
                <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.casteCertificate, basicInfoCasteCertFileType, 'Caste Certificate')">{{ basicInfoCasteCertFileType === 'application/pdf' ? 'Certificate.pdf' : 'Certificate' }}</a>
              </div>
            </ng-container>
            <ng-template #casteUpload>
              <label for="gv2-basicinfo-caste-input" class="gv2-basicinfo-upload-btn">
                <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
              </label>
            </ng-template>
            <input id="gv2-basicinfo-caste-input" type="file" style="display:none" (change)="onBasicInfoCasteCertSelected($event)" />
          </div>

          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ brand.nationalIdCopyLabelKey | translate }}</label>
            <ng-container *ngIf="basicInfoData.aadharCopy; else aadharUpload">
              <div class="gv2-basicinfo-doc-chip">
                <i class="ri-checkbox-circle-fill"></i>
                <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.aadharCopy, basicInfoAadharFileType, nationalIdCopyLabel)">{{ basicInfoAadharFileType === 'application/pdf' ? 'AadharCopy.pdf' : 'AadharCopy' }}</a>
              </div>
            </ng-container>
            <ng-template #aadharUpload>
              <label for="gv2-basicinfo-aadhar-input" class="gv2-basicinfo-upload-btn gv2-basicinfo-upload-btn-wide">
                <i class="ri-upload-2-line"></i> {{ brand.nationalIdCopyUploadLabelKey | translate }}
              </label>
            </ng-template>
            <input id="gv2-basicinfo-aadhar-input" type="file" style="display:none" (change)="onBasicInfoAadharCopySelected($event)" />
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <!-- Special Categories -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.specialCategories' | translate }}
        </div>
        <div class="gv2-basicinfo-special-list">
          <div class="gv2-basicinfo-special-row">
            <label class="gv2-basicinfo-checkbox">
              <input type="checkbox" [checked]="basicInfoData.isMinority" (change)="onBasicInfoMinorityChange($event)" />
              {{ 'groupsV2.belongsToMinority' | translate }}
            </label>
          </div>

          <div class="gv2-basicinfo-special-row">
            <label class="gv2-basicinfo-checkbox">
              <input type="checkbox" [checked]="basicInfoData.isSpeciallyAbled == '1' || basicInfoData.speciallyAbledCertificate" (change)="onBasicInfoSpeciallyAbledChange($event)" />
              {{ 'groupsV2.speciallyAbled' | translate }}
            </label>
            <ng-container *ngIf="basicInfoData.isSpeciallyAbled == '1' || basicInfoData.speciallyAbledCertificate">
              <ng-container *ngIf="basicInfoData.speciallyAbledCertificate; else speciallyAbledUpload">
                <div class="gv2-basicinfo-doc-chip">
                  <i class="ri-checkbox-circle-fill"></i>
                  <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.speciallyAbledCertificate, basicInfoSpeciallyAbledFileType, 'Specially Abled Certificate')">Certificate</a>
                </div>
              </ng-container>
              <ng-template #speciallyAbledUpload>
                <label for="gv2-basicinfo-specially-abled-input" class="gv2-basicinfo-upload-btn">
                  <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
                </label>
              </ng-template>
              <input id="gv2-basicinfo-specially-abled-input" type="file" style="display:none" (change)="onBasicInfoSpeciallyAbledCertSelected($event)" />
            </ng-container>
          </div>

          <div class="gv2-basicinfo-special-row" *ngIf="basicInfoData.cast === 'General'">
            <label class="gv2-basicinfo-checkbox">
              <input type="checkbox" [checked]="basicInfoData.isEWSCategory == '1' || basicInfoData.ewsCertificate" (change)="onBasicInfoEWSCategoryChange($event)" />
              {{ 'groupsV2.belongsToEWS' | translate }}
            </label>
            <ng-container *ngIf="basicInfoData.isEWSCategory == '1' || basicInfoData.ewsCertificate">
              <ng-container *ngIf="basicInfoData.ewsCertificate; else ewsUpload">
                <div class="gv2-basicinfo-doc-chip">
                  <i class="ri-checkbox-circle-fill"></i>
                  <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.ewsCertificate, basicInfoEwsCertFileType, 'EWS Certificate')">Certificate</a>
                </div>
              </ng-container>
              <ng-template #ewsUpload>
                <label for="gv2-basicinfo-ews-input" class="gv2-basicinfo-upload-btn">
                  <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
                </label>
              </ng-template>
              <input id="gv2-basicinfo-ews-input" type="file" style="display:none" (change)="onBasicInfoEwsCertSelected($event)" />
            </ng-container>
          </div>

          <div class="gv2-basicinfo-special-row" *ngIf="basicInfoData.gender == 0">
            <label class="gv2-basicinfo-checkbox">
              <input type="checkbox" [checked]="basicInfoData.isSingleGirlChild == '1' || basicInfoData.singleGirlChildCertificate" (change)="onBasicInfoSingleGirlChildChange($event)" />
              {{ 'groupsV2.singleGirlChild' | translate }}
            </label>
            <ng-container *ngIf="basicInfoData.isSingleGirlChild == '1' || basicInfoData.singleGirlChildCertificate">
              <ng-container *ngIf="basicInfoData.singleGirlChildCertificate; else singleGirlUpload">
                <div class="gv2-basicinfo-doc-chip">
                  <i class="ri-checkbox-circle-fill"></i>
                  <a href="javascript:void(0)" (click)="previewBasicInfoDoc(basicInfoData.singleGirlChildCertificate, basicInfoSingleGirlCertFileType, 'Single Girl Child Certificate')">Certificate</a>
                </div>
              </ng-container>
              <ng-template #singleGirlUpload>
                <label for="gv2-basicinfo-single-girl-input" class="gv2-basicinfo-upload-btn">
                  <i class="ri-upload-2-line"></i> {{ 'groupsV2.upload' | translate }}
                </label>
              </ng-template>
              <input id="gv2-basicinfo-single-girl-input" type="file" style="display:none" (change)="onBasicInfoSingleGirlCertSelected($event)" />
            </ng-container>
          </div>
        </div>
      </form>

      <!-- Class-change-blocked warning (mirrors shared component's inline warning) -->
      <div *ngIf="basicInfoShowClassChangeWarning" class="gv2-basicinfo-warning">
        <p>{{ 'groupsV2.classChangeNotAllowed' | translate: { name: studentBasicInfoStudentName, oldClass: basicInfoClassChangeError.oldClassName, newClass: basicInfoClassChangeError.newClassName } }}</p>
        <p><strong>{{ 'groupsV2.reasonColon' | translate }}</strong></p>
        <p>{{ 'groupsV2.classChangeReason1' | translate: { oldClass: basicInfoClassChangeError.oldClassName, newClass: basicInfoClassChangeError.newClassName, structure: basicInfoClassChangeError.structureName } }}</p>
        <p>{{ 'groupsV2.classChangeReason2' | translate: { name: studentBasicInfoStudentName, currency: schoolCurrency, amount: basicInfoClassChangeError.paidAmount } }}</p>
        <p>{{ 'groupsV2.classChangeMoveAnyway' | translate: { name: studentBasicInfoStudentName, newClass: basicInfoClassChangeError.newClassName } }}</p>
        <button type="button" class="gv2-btn-outline" (click)="closeBasicInfoFeesNotification()">{{ 'groupsV2.revert' | translate }}</button>
      </div>
    </div>

    <div class="gv2-modal-footer" *ngIf="!basicInfoShowClassChangeWarning">
      <button type="button" class="gv2-btn-outline" (click)="studentBasicInfoPopupClose()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient gv2-basicinfo-save-btn" [disabled]="basicInfoSaving || basicInfoLoading" (click)="saveBasicInfo()">
        <i class="ri-save-3-line"></i> {{ (basicInfoSaving ? 'groupsV2.saving' : 'groupsV2.saveChanges') | translate }}
      </button>
    </div>
  </div>
</p-dialog>

<!-- Contact Details - native groups-v2 replacement for the shared
     <app-student-contact-info> component. Same visual pattern as the Update
     Basic Info popup (gv2-basicinfo-* header/skeleton/field/grid classes). -->
<p-dialog [(visible)]="openStudentContactInfoPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-basicinfo-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="studentContactInfoPopupClose()">
  <div class="gv2-basicinfo-modal">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-contacts-book-2-line"></i></div>
        <div>
          <h3>{{ 'groupsV2.contactDetailsTitle' | translate }}</h3>
          <p>{{ studentContactInfoStudentName }}</p>
        </div>
      </div>
      <button type="button" class="gv2-basicinfo-close-btn" (click)="studentContactInfoPopupClose()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="gv2-modal-body gv2-basicinfo-body">
      <div *ngIf="contactInfoLoading && !contactInfoData.studentId" class="gv2-basicinfo-skeleton">
        <span class="gv2-skeleton-bar" *ngFor="let r of contactInfoSkeletonRows"></span>
      </div>

      <form *ngIf="contactInfoData.studentId || !contactInfoLoading" class="gv2-basicinfo-form">
        <!-- Father -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.fathersInfo' | translate }}
        </div>
        <div class="gv2-contactinfo-person-row">
          <div class="gv2-contactinfo-photo-col">
            <div class="gv2-contactinfo-photo-wrap">
              <div class="gv2-contactinfo-photo">
                <img *ngIf="contactInfoFatherImagePreview" [src]="contactInfoFatherImagePreview" alt="" />
                <i *ngIf="!contactInfoFatherImagePreview" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-contactinfo-father-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-contactinfo-father-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onContactInfoImageSelected($event, 'father')" />
            </div>
            <button type="button" class="gv2-contactinfo-remove-btn"
              [class.gv2-contactinfo-remove-btn-hidden]="!contactInfoFatherImagePreview || contactInfoFatherImagePreview === contactInfoData.defaultImageURL"
              (click)="removeContactInfoImage('father')">
              <i class="ri-delete-bin-6-line"></i> {{ 'groupsV2.remove' | translate }}
            </button>
          </div>
          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.fathersName' | translate }}<span class="gv2-required">*</span></label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.staffNamePlaceholder' | translate }}" [(ngModel)]="contactInfoData.parentName" name="parentName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.contactNumberLabel' | translate }}<span class="gv2-required">*</span></label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidFatherContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoFatherCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoFatherCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-father-phone" [attr.maxlength]="contactInfoFatherCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoFatherContact" (ngModelChange)="onContactInfoFatherContactInput($event)"
                  name="fatherContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.alternateMobileNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidFatherAltContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoFatherAltCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoFatherAltCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-father-alt-phone" [attr.maxlength]="contactInfoFatherAltCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoFatherAltContact" (ngModelChange)="onContactInfoFatherAltContactInput($event)"
                  name="fatherAltContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label><i class="fa fa-whatsapp"></i> {{ 'groupsV2.whatsappNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidFatherWhatsapp">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoFatherWhatsappCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoFatherWhatsappCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-father-whatsapp" [attr.maxlength]="contactInfoFatherWhatsappCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoFatherWhatsapp" (ngModelChange)="onContactInfoFatherWhatsappInput($event)"
                  name="fatherWhatsapp" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.occupation' | translate }}</label>
              <select class="gv2-basicinfo-input" [(ngModel)]="contactInfoData.fatherOccupation" name="fatherOccupation" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.selectOccupation' | translate }}</option>
                <option *ngFor="let o of contactInfoOccupationList" [ngValue]="o.value">{{ o.name }}</option>
              </select>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.educationalQualification' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. B.Ed, M.Sc Mathematics" [(ngModel)]="contactInfoData.fatherQualification" name="fatherQualification" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.annualIncome' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. 500000" [(ngModel)]="contactInfoData.fatherAnnualIncome" name="fatherAnnualIncome" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.pinCode' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" maxlength="6" placeholder="e.g. 560001" [(ngModel)]="contactInfoData.fatherPinCode" name="fatherPinCode" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.fatherEmail' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.emailPlaceholder' | translate }}" [(ngModel)]="contactInfoData.emailId" name="emailId" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
              <label>{{ 'groupsV2.contactAddress' | translate }}<span class="gv2-required">*</span></label>
              <textarea class="gv2-basicinfo-input" rows="3" placeholder="{{ 'groupsV2.contactAddressPlaceholder' | translate }}" [(ngModel)]="contactInfoData.address" name="fatherAddress" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <!-- Mother -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.mothersInfo' | translate }}
        </div>
        <div class="gv2-contactinfo-person-row">
          <div class="gv2-contactinfo-photo-col">
            <div class="gv2-contactinfo-photo-wrap">
              <div class="gv2-contactinfo-photo">
                <img *ngIf="contactInfoMotherImagePreview" [src]="contactInfoMotherImagePreview" alt="" />
                <i *ngIf="!contactInfoMotherImagePreview" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-contactinfo-mother-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-contactinfo-mother-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onContactInfoImageSelected($event, 'mother')" />
            </div>
            <button type="button" class="gv2-contactinfo-remove-btn"
              [class.gv2-contactinfo-remove-btn-hidden]="!contactInfoMotherImagePreview || contactInfoMotherImagePreview === contactInfoData.defaultImageURL"
              (click)="removeContactInfoImage('mother')">
              <i class="ri-delete-bin-6-line"></i> {{ 'groupsV2.remove' | translate }}
            </button>
          </div>
          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.mothersName' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. Jane Doe" [(ngModel)]="contactInfoData.motherName" name="motherName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.contactNumberLabel' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidMotherContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoMotherCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoMotherCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-mother-phone" [attr.maxlength]="contactInfoMotherCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoMotherContact" (ngModelChange)="onContactInfoMotherContactInput($event)"
                  name="motherContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.alternateMobileNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidMotherAltContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoMotherAltCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoMotherAltCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-mother-alt-phone" [attr.maxlength]="contactInfoMotherAltCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoMotherAltContact" (ngModelChange)="onContactInfoMotherAltContactInput($event)"
                  name="motherAltContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label><i class="fa fa-whatsapp"></i> {{ 'groupsV2.whatsappNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidMotherWhatsapp">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoMotherWhatsappCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoMotherWhatsappCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-mother-whatsapp" [attr.maxlength]="contactInfoMotherWhatsappCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoMotherWhatsapp" (ngModelChange)="onContactInfoMotherWhatsappInput($event)"
                  name="motherWhatsapp" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.occupation' | translate }}</label>
              <select class="gv2-basicinfo-input" [(ngModel)]="contactInfoData.motherOccupation" name="motherOccupation" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.selectOccupation' | translate }}</option>
                <option *ngFor="let o of contactInfoOccupationList" [ngValue]="o.value">{{ o.name }}</option>
              </select>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.educationalQualification' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. B.A, M.Com" [(ngModel)]="contactInfoData.motherQualification" name="motherQualification" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.annualIncome' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. 500000" [(ngModel)]="contactInfoData.motherAnnualIncome" name="motherAnnualIncome" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.pinCode' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" maxlength="6" placeholder="e.g. 560001" [(ngModel)]="contactInfoData.motherPinCode" name="motherPinCode" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.motherEmail' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. jane.doe@school.com" [(ngModel)]="contactInfoData.motherEmail" name="motherEmail" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
              <label>{{ 'groupsV2.contactAddress' | translate }}</label>
              <textarea class="gv2-basicinfo-input" rows="3" placeholder="{{ 'groupsV2.contactAddressPlaceholder' | translate }}" [(ngModel)]="contactInfoData.motherAddress" name="motherAddress" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>

        <div class="gv2-basicinfo-divider"></div>

        <!-- Guardian -->
        <div class="gv2-basicinfo-section-title">
          <span class="gv2-basicinfo-accent-bar"></span> {{ 'groupsV2.guardiansInfo' | translate }}
        </div>
        <div class="gv2-contactinfo-person-row">
          <div class="gv2-contactinfo-photo-col">
            <div class="gv2-contactinfo-photo-wrap">
              <div class="gv2-contactinfo-photo">
                <img *ngIf="contactInfoGuardianImagePreview" [src]="contactInfoGuardianImagePreview" alt="" />
                <i *ngIf="!contactInfoGuardianImagePreview" class="ri-user-3-line"></i>
              </div>
              <label for="gv2-contactinfo-guardian-photo-input" class="gv2-basicinfo-photo-camera-btn">
                <i class="ri-camera-line"></i>
              </label>
              <input id="gv2-contactinfo-guardian-photo-input" type="file" accept="image/*" style="display:none"
                (change)="onContactInfoImageSelected($event, 'guardian')" />
            </div>
            <button type="button" class="gv2-contactinfo-remove-btn"
              [class.gv2-contactinfo-remove-btn-hidden]="!contactInfoGuardianImagePreview || contactInfoGuardianImagePreview === contactInfoData.defaultImageURL"
              (click)="removeContactInfoImage('guardian')">
              <i class="ri-delete-bin-6-line"></i> {{ 'groupsV2.remove' | translate }}
            </button>
          </div>
          <div class="gv2-basicinfo-grid">
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.guardiansName' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="{{ 'groupsV2.staffNamePlaceholder' | translate }}" [(ngModel)]="contactInfoData.guardianName" name="guardianName" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.contactNumberLabel' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidGuardianContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoGuardianCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoGuardianCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-guardian-phone" [attr.maxlength]="contactInfoGuardianCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoGuardianContact" (ngModelChange)="onContactInfoGuardianContactInput($event)"
                  name="guardianContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.alternateMobileNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidGuardianAltContact">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoGuardianAltCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoGuardianAltCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-guardian-alt-phone" [attr.maxlength]="contactInfoGuardianAltCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoGuardianAltContact" (ngModelChange)="onContactInfoGuardianAltContactInput($event)"
                  name="guardianAltContact" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label><i class="fa fa-whatsapp"></i> {{ 'groupsV2.whatsappNumber' | translate }}</label>
              <div class="gv2-contactinfo-phone-row" [class.gv2-basicinfo-input-error]="contactInfoInvalidGuardianWhatsapp">
                <ngx-country-select class="gv2-contactinfo-country-select" [defaultIso2]="brand.defaultCountryIso2Upper || 'IN'"
                  [ngModel]="contactInfoGuardianWhatsappCountry" [ngModelOptions]="{standalone: true}"
                  (countryChange)="onContactInfoGuardianWhatsappCountryChange($event)"></ngx-country-select>
                <input type="text" id="gv2-contactinfo-guardian-whatsapp" [attr.maxlength]="contactInfoGuardianWhatsappCountry?.maxLength || 20" placeholder="{{ 'groupsV2.mobileNumberPlaceholder' | translate }}"
                  [ngModel]="contactInfoGuardianWhatsapp" (ngModelChange)="onContactInfoGuardianWhatsappInput($event)"
                  name="guardianWhatsapp" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.occupation' | translate }}</label>
              <select class="gv2-basicinfo-input" [(ngModel)]="contactInfoData.guardianOccupation" name="guardianOccupation" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">{{ 'groupsV2.selectOccupation' | translate }}</option>
                <option *ngFor="let o of contactInfoOccupationList" [ngValue]="o.value">{{ o.name }}</option>
              </select>
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.educationalQualification' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. B.Sc, MBA" [(ngModel)]="contactInfoData.guardianQualification" name="guardianQualification" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.annualIncome' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" placeholder="e.g. 500000" [(ngModel)]="contactInfoData.guardianAnnualIncome" name="guardianAnnualIncome" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field">
              <label>{{ 'groupsV2.pinCode' | translate }}</label>
              <input type="text" class="gv2-basicinfo-input" maxlength="6" placeholder="e.g. 560001" [(ngModel)]="contactInfoData.guardianPinCode" name="guardianPinCode" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
              <label>{{ 'groupsV2.contactAddress' | translate }}</label>
              <textarea class="gv2-basicinfo-input" rows="3" placeholder="{{ 'groupsV2.contactAddressPlaceholder' | translate }}" [(ngModel)]="contactInfoData.guardianAddress" name="guardianAddress" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="gv2-modal-footer">
      <button type="button" class="gv2-btn-outline" (click)="studentContactInfoPopupClose()">{{ 'groupsV2.cancel' | translate }}</button>
      <button type="button" class="gv2-btn-gradient gv2-basicinfo-save-btn" [disabled]="contactInfoSaving || contactInfoLoading" (click)="saveContactInfo()">
        <i class="ri-save-3-line"></i> {{ (contactInfoSaving ? 'groupsV2.saving' : 'groupsV2.saveChanges') | translate }}
      </button>
    </div>
  </div>
</p-dialog>

<!-- Student profile print preview - native p-dialog reimplementation of
     app-student-profile-view (same service call/fields/print behavior),
     see printStudentProfile() comment for why this isn't the shared
     component directly. -->
<p-dialog [(visible)]="openStudentProfileViewPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-history-dialog" maskStyleClass="gv2-history-dialog-mask"
  (onHide)="studentProfileViewClose()">
  <div class="gv2-history-modal gv2-profile-modal">
    <button type="button" class="gv2-history-close-btn" (click)="studentProfileViewClose()">
      <i class="ri-close-line"></i>
    </button>

    <div class="gv2-history-header">
      <div class="gv2-history-header-icon">
        <i class="ri-user-3-line"></i>
      </div>
      <div>
        <h3>{{ studentProfileViewStudentName }}{{ 'groupsV2.profileOf' | translate }}</h3>
        <p>{{ 'groupsV2.studentProfileSummary' | translate }}</p>
      </div>
      <button type="button" class="gv2-btn-outline gv2-profile-print-btn"
              *ngIf="!fetchingStudentProfile" (click)="printStudentProfile()">
        <i class="ri-printer-line"></i> {{ 'groupsV2.print' | translate }}
      </button>
    </div>

    <div class="gv2-modal-body gv2-history-body">
      <div *ngIf="fetchingStudentProfile" class="gv2-profile-skeleton">
        <span class="gv2-skeleton-bar gv2-profile-skeleton-avatar"></span>
        <span class="gv2-skeleton-bar" *ngFor="let r of profileSkeletonRows"></span>
      </div>

      <div *ngIf="!fetchingStudentProfile" id="gv2-student-profile-print-container" class="gv2-profile-print-container">
        <div class="gv2-profile-header">
          <h3>{{ studentProfile.schoolName }}</h3>
          <h5>{{ studentProfile.schoolAddress }}</h5>
        </div>
        <div class="gv2-profile-avatar-row">
          <img [src]="studentProfile.studentImage" alt="" class="gv2-profile-avatar" />
        </div>

        <h4 class="gv2-profile-section-title">{{ 'groupsV2.personalDetails' | translate }}</h4>
        <table class="gv2-profile-table">
          <tr>
            <th>{{ 'groupsV2.studentNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.studentName }}</td>
            <th>{{ 'groupsV2.surnameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.surname || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.fatherNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.parentName }}</td>
            <th>{{ 'groupsV2.motherNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.motherName || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.mobileNumberProfileLabel' | translate }}</th><td>:</td><td>{{ studentProfile.mobileNumber }}</td>
            <th>{{ 'groupsV2.houseNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.houseName || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.dateOfBirthBasicLabel' | translate }}</th><td>:</td><td>{{ formatProfileDate(studentProfile.dateOfBirth) }}</td>
            <th>{{ 'groupsV2.genderProfileLabel' | translate }}</th><td>:</td><td>{{ studentProfile.gender || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.addressProfileLabel' | translate }}</th><td>:</td><td colspan="4">{{ studentProfile.address || '-' }}</td>
          </tr>
        </table>

        <h4 class="gv2-profile-section-title">{{ 'groupsV2.academicDetails' | translate }}</h4>
        <table class="gv2-profile-table">
          <tr>
            <th>{{ 'groupsV2.academicYearLabel' | translate }}</th><td>:</td><td>{{ profileAcademicInfo.academicYear }}</td>
            <th>{{ 'groupsV2.busNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.BusName || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.admissionDateLabel' | translate }}</th><td>:</td><td>{{ formatProfileDate(studentProfile.dateOfAdmission) }}</td>
            <th>{{ 'groupsV2.busNumberLabel' | translate }}</th><td>:</td><td>{{ studentProfile.BusNumber || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.admissionNumberProfileLabel' | translate }}</th><td>:</td><td>{{ studentProfile.registrationId || '-' }}</td>
            <th>{{ 'groupsV2.busStopNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.BusStopName || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.classNameLabel' | translate }}</th><td>:</td><td>{{ studentProfile.className }}</td>
            <th>{{ 'groupsV2.busRouteLabel' | translate }}</th><td>:</td><td>{{ studentProfile.BusRoute || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.rollNumberProfileLabel' | translate }}</th><td>:</td><td colspan="4">{{ studentProfile.rollNumber || '-' }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.admittedClassLabel' | translate }}</th><td>:</td><td colspan="4">{{ studentProfile.admittedClass }}</td>
          </tr>
          <tr>
            <th>{{ 'groupsV2.admittedAcademicYearLabel' | translate }}</th><td>:</td><td colspan="4">{{ studentProfile.admittedAcademic }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Document hub -->
<p-dialog [(visible)]="openDocumentHubPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-dochub-dialog" maskStyleClass="gv2-basicinfo-dialog-mask"
  (onHide)="closeDocumentHubPopup()">
  <div class="gv2-dochub-modal" (click)="closeDocumentHubActions()">
    <div class="gv2-basicinfo-header">
      <div class="gv2-basicinfo-header-left">
        <div class="gv2-basicinfo-header-icon"><i class="ri-file-fill"></i></div>
        <div>
          <h3>{{ 'groupsV2.documentHubTitle' | translate }}</h3>
          <p>{{ documentHubStudentName }} &middot; {{ documentHubRegistrationId }}</p>
        </div>
      </div>
      <div class="gv2-dochub-header-right">
        <div class="gv2-dochub-search" *ngIf="!documentHubShowUpload && documentHubUploadedList.length > 0 && !fetchingDocumentHub"
          (click)="$event.stopPropagation()">
          <i class="ri-search-line"></i>
          <input type="text" placeholder="{{ 'groupsV2.searchByDocType' | translate }}"
            [ngModel]="documentHubSearchQuery" (ngModelChange)="searchDocumentHubByTitle($event)"
            [ngModelOptions]="{standalone: true}" />
        </div>
        <button type="button" class="gv2-basicinfo-close-btn" (click)="closeDocumentHubPopup()">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </div>

    <div class="gv2-dochub-body" [class.gv2-dochub-body-list]="!documentHubShowUpload">
      <!-- List view -->
      <ng-container *ngIf="!documentHubShowUpload">
        <div class="gv2-dochub-table-wrap">
          <div *ngIf="fetchingDocumentHub" class="gv2-dochub-state">
            <span class="gv2-dochub-spinner"></span> {{ 'groupsV2.loadingDocuments' | translate }}
          </div>

          <div *ngIf="!fetchingDocumentHub && documentHubData.length === 0" class="gv2-dochub-state gv2-dochub-empty">
            <i class="ri-file-list-3-line"></i>
            <p>{{ 'groupsV2.noDocumentsAvailable' | translate }}</p>
          </div>

          <ng-container *ngIf="!fetchingDocumentHub && documentHubData.length > 0">
            <div class="gv2-dochub-section-title" *ngIf="documentHubNormalData.length > 0 && documentHubMedicalData.length > 0">
              {{ 'groupsV2.documentsSectionTitle' | translate }}
            </div>
            <table class="gv2-dochub-table" *ngIf="documentHubNormalData.length > 0">
              <thead>
                <tr>
                  <th>{{ 'groupsV2.documentTypeCol' | translate }}</th>
                  <th>{{ 'groupsV2.titleCol' | translate }}</th>
                  <th>{{ 'groupsV2.descriptionCol' | translate }}</th>
                  <th>{{ 'groupsV2.uploadedOnCol' | translate }}</th>
                  <th>{{ 'groupsV2.uploadedByCol' | translate }}</th>
                  <th class="gv2-dochub-actions-head"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documentHubNormalData; let i = index"
                  [class.gv2-dochub-row-disabled]="documentHubDeleting"
                  (click)="previewDocumentHubDoc(doc, i); $event.stopPropagation()">
                  <td>{{ doc.documentTypeName }}</td>
                  <td>{{ doc.documentTitle }}</td>
                  <td class="gv2-dochub-desc" [title]="doc.documentDescription">{{ doc.documentDescription }}</td>
                  <td>{{ doc.createdOn }}</td>
                  <td>{{ doc.createdBy }}</td>
                  <td class="gv2-dochub-actions-cell">
                    <span *ngIf="documentHubPreviewingIndex === i" class="gv2-dochub-actions-cell-spinner-wrap">
                      <span class="gv2-dochub-spinner"></span>
                    </span>
                    <i *ngIf="documentHubPreviewingIndex !== i" class="ri-more-2-fill"
                      (click)="openDocumentHubActions(i); $event.stopPropagation()"></i>
                    <div *ngIf="documentHubOpenActionIndex === i" class="gv2-dochub-actions-menu" (click)="$event.stopPropagation()">
                      <div class="gv2-dochub-actions-menu-item gv2-dochub-danger" (click)="deleteDocumentHubDoc(doc)">
                        <span *ngIf="!documentHubDeleting">{{ 'groupsV2.delete' | translate }}</span>
                        <span *ngIf="documentHubDeleting" class="gv2-dochub-spinner"></span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Medical documents get their own table, with disease-specific
                 column labels (labelOfTitle/labelOfDescription from the
                 matching document type) instead of the generic Title/
                 Description headers used above. -->
            <div class="gv2-dochub-section-title gv2-dochub-medical-title"
              [class.gv2-dochub-medical-title-divider]="documentHubNormalData.length > 0"
              *ngIf="documentHubMedicalData.length > 0">
              <i class="ri-heart-pulse-line"></i> {{ 'groupsV2.medicalDocumentsSectionTitle' | translate }}
            </div>
            <table class="gv2-dochub-table gv2-dochub-table-medical" *ngIf="documentHubMedicalData.length > 0">
              <thead>
                <tr>
                  <th>{{ medicalDocumentType?.labelOfTitle || ('groupsV2.titleCol' | translate) }}</th>
                  <th>{{ medicalDocumentType?.labelOfDescription || ('groupsV2.descriptionCol' | translate) }}</th>
                  <th>{{ 'groupsV2.uploadedOnCol' | translate }}</th>
                  <th>{{ 'groupsV2.uploadedByCol' | translate }}</th>
                  <th class="gv2-dochub-actions-head"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documentHubMedicalData; let i = index"
                  [class.gv2-dochub-row-disabled]="documentHubDeleting"
                  (click)="previewDocumentHubDoc(doc, 'm' + i); $event.stopPropagation()">
                  <td>{{ doc.documentTitle }}</td>
                  <td class="gv2-dochub-desc" [title]="doc.documentDescription">{{ doc.documentDescription }}</td>
                  <td>{{ doc.createdOn }}</td>
                  <td>{{ doc.createdBy }}</td>
                  <td class="gv2-dochub-actions-cell">
                    <span *ngIf="documentHubPreviewingIndex === ('m' + i)" class="gv2-dochub-actions-cell-spinner-wrap">
                      <span class="gv2-dochub-spinner"></span>
                    </span>
                    <i *ngIf="documentHubPreviewingIndex !== ('m' + i)" class="ri-more-2-fill"
                      (click)="openDocumentHubActions('m' + i); $event.stopPropagation()"></i>
                    <div *ngIf="documentHubOpenActionIndex === ('m' + i)"
                      class="gv2-dochub-actions-menu gv2-dochub-actions-menu-up" (click)="$event.stopPropagation()">
                      <div class="gv2-dochub-actions-menu-item gv2-dochub-danger" (click)="deleteDocumentHubDoc(doc)">
                        <span *ngIf="!documentHubDeleting">{{ 'groupsV2.delete' | translate }}</span>
                        <span *ngIf="documentHubDeleting" class="gv2-dochub-spinner"></span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </div>
      </ng-container>

      <button type="button" class="gv2-dochub-fab" *ngIf="!documentHubShowUpload"
        (click)="toggleDocumentHubUpload(); $event.stopPropagation()">
        <i class="ri-add-line"></i>
        <span class="gv2-dochub-fab-label">{{ 'groupsV2.addDocument' | translate }}</span>
      </button>

      <!-- Upload view -->
      <ng-container *ngIf="documentHubShowUpload">
        <div class="gv2-dochub-upload-grid">
          <div class="gv2-basicinfo-field">
            <label>{{ 'groupsV2.documentTypeLabel' | translate }}<span class="gv2-required">*</span></label>
            <div class="gv2-dochub-select-wrap">
              <select class="gv2-basicinfo-input" [disabled]="documentHubFetchingTypes" [(ngModel)]="documentHubSelectedType" name="documentHubType" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null" hidden>{{ (documentHubFetchingTypes ? 'groupsV2.loadingEllipsis' : 'groupsV2.selectDocumentType') | translate }}</option>
                <option *ngFor="let item of documentHubTypesInfo" [ngValue]="item">{{ item.documentTypeName }}</option>
              </select>
              <span *ngIf="documentHubFetchingTypes" class="gv2-dochub-spinner gv2-dochub-select-spinner"></span>
            </div>
          </div>
          <div class="gv2-basicinfo-field">
            <label>{{ documentHubSelectedType?.labelOfTitle || ('groupsV2.documentTitleLabel' | translate) }}<span class="gv2-required" *ngIf="isDocumentHubTitleRequired"><sup>*</sup></span></label>
            <input #documentHubTitle type="text" maxlength="50" class="gv2-basicinfo-input" />
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ 'groupsV2.uploadDocumentLabel' | translate }}<span class="gv2-required">*</span></label>
            <label for="gv2-dochub-file-input" class="gv2-basicinfo-upload-btn gv2-basicinfo-upload-btn-wide">
              <i class="ri-upload-2-line"></i> {{ documentHubSelectedFile ? documentHubSelectedFile.name : ('groupsV2.chooseFile' | translate) }}
            </label>
            <input #documentHubFileInput id="gv2-dochub-file-input" type="file" style="display:none"
              [attr.accept]="documentHubSelectedType ? documentHubSelectedType.allowedFormat : null"
              (change)="onDocumentHubFileSelected($event)" />
          </div>
          <div class="gv2-basicinfo-field gv2-basicinfo-field-full">
            <label>{{ documentHubSelectedType?.labelOfDescription || ('groupsV2.descriptionLabel' | translate) }}<span class="gv2-required" *ngIf="isDocumentHubDescriptionRequired"><sup>*</sup></span></label>
            <textarea #documentHubDescription maxlength="200" rows="4" class="gv2-basicinfo-input"></textarea>
          </div>
        </div>

        <div class="gv2-dochub-footer gv2-dochub-footer-split">
          <button type="button" class="gv2-btn-outline" [disabled]="documentHubUploading" (click)="toggleDocumentHubUpload()">{{ 'groupsV2.cancel' | translate }}</button>
          <button type="button" class="gv2-btn-gradient" [disabled]="documentHubUploading"
            (click)="uploadDocumentHubFile(documentHubTitle.value, documentHubDescription.value)">
            <span *ngIf="!documentHubUploading">{{ 'groupsV2.upload' | translate }}</span>
            <span *ngIf="documentHubUploading" class="gv2-dochub-spinner gv2-dochub-spinner-light"></span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>

<!-- Student update history - minimal native modal -->
<p-dialog [(visible)]="openStudentUpdateHistoryPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="gv2-history-dialog" maskStyleClass="gv2-history-dialog-mask"
  (onHide)="closeStudentUpdateHistoryPopup()">
  <div class="gv2-history-modal">
    <button type="button" class="gv2-history-close-btn" (click)="closeStudentUpdateHistoryPopup()">
      <i class="ri-close-line"></i>
    </button>

    <div class="gv2-history-header">
      <div class="gv2-history-header-icon">
        <i class="ri-history-line"></i>
      </div>
      <div>
        <h3>{{ 'groupsV2.updateHistoryTitle' | translate }}</h3>
        <p>{{ 'groupsV2.updateHistoryHint' | translate }}</p>
      </div>
    </div>

    <div class="gv2-history-chips">
      <span class="gv2-history-chip">
        <i class="ri-file-list-2-line"></i> {{ 'groupsV2.regNoLabel' | translate }} <strong>{{ studentUpdateHistoryRegistrationId }}</strong>
      </span>
      <span class="gv2-history-chip">
        <i class="ri-user-line"></i> {{ 'groupsV2.studentLabelChip' | translate }} <strong>{{ studentUpdateHistoryStudentName }}</strong>
      </span>
      <span class="gv2-history-chip">
        <i class="ri-time-line"></i> <strong>{{ filteredHistoryList.length }}</strong> {{ 'groupsV2.changesLabel' | translate }}
      </span>
    </div>

    <div class="gv2-history-toolbar">
      <div class="gv2-entries">
        {{ 'groupsV2.show' | translate }}
        <select class="gv2-native-select" [ngModel]="historyPageSize" (ngModelChange)="onHistoryPageSizeChange($event)"
                [ngModelOptions]="{standalone: true}">
          <option *ngFor="let size of historyPageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        {{ 'groupsV2.entries' | translate }}
      </div>
      <div class="gv2-search-box">
        <i class="ri-search-line"></i>
        <input type="text" placeholder="{{ 'groupsV2.searchChangesPlaceholder' | translate }}" [ngModel]="historySearchTerm"
               (ngModelChange)="onHistorySearchChange($event)" [ngModelOptions]="{standalone: true}" />
      </div>
    </div>

    <div class="gv2-modal-body gv2-history-body">
      <table class="gv2-history-table" *ngIf="fetchingStudentUpdateHistory">
        <thead>
          <tr><th>{{ 'groupsV2.fieldCol' | translate }}</th><th>{{ 'groupsV2.oldValueCol' | translate }}</th><th>{{ 'groupsV2.newValueCol' | translate }}</th><th>{{ 'groupsV2.updatedByCol' | translate }}</th><th>{{ 'groupsV2.updatedOnCol' | translate }}</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of historySkeletonRows" class="gv2-skeleton-row">
            <td><span class="gv2-skeleton-bar"></span></td>
            <td><span class="gv2-skeleton-bar"></span></td>
            <td><span class="gv2-skeleton-bar"></span></td>
            <td><span class="gv2-skeleton-bar"></span></td>
            <td><span class="gv2-skeleton-bar"></span></td>
          </tr>
        </tbody>
      </table>
      <table class="gv2-history-table" *ngIf="!fetchingStudentUpdateHistory && pagedHistoryList.length > 0">
        <thead>
          <tr><th>{{ 'groupsV2.fieldCol' | translate }}</th><th>{{ 'groupsV2.oldValueCol' | translate }}</th><th>{{ 'groupsV2.newValueCol' | translate }}</th><th>{{ 'groupsV2.updatedByCol' | translate }}</th><th>{{ 'groupsV2.updatedOnCol' | translate }}</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let tr of pagedHistoryList">
            <td>
              <div class="gv2-history-field">
                <span class="gv2-history-field-icon"><i [ngClass]="historyFieldIcon(tr.ColumnName)"></i></span>
                <strong>{{ formatHistoryColumnName(tr.ColumnName) }}</strong>
              </div>
            </td>
            <td>
              <ng-container *ngIf="isHistoryUrlValue(tr.OldValue); else oldText">
                <div class="gv2-history-image-chip" (click)="previewHistoryImage(tr.OldValue)">
                  <img [src]="tr.OldValue" alt="" />
                </div>
              </ng-container>
              <ng-template #oldText>
                <span class="gv2-history-value-chip">{{ tr.OldValue || '—' }}</span>
              </ng-template>
            </td>
            <td>
              <ng-container *ngIf="isHistoryUrlValue(tr.NewValue); else newText">
                <div class="gv2-history-image-chip" (click)="previewHistoryImage(tr.NewValue)">
                  <img [src]="tr.NewValue" alt="" />
                </div>
              </ng-container>
              <ng-template #newText>
                <span class="gv2-history-value-chip">{{ tr.NewValue || '—' }}</span>
              </ng-template>
            </td>
            <td>
              <div class="gv2-history-updated-by">
                <span class="gv2-history-avatar">{{ (tr.UpdatedBy || '?').charAt(0).toUpperCase() }}</span>
                {{ tr.UpdatedBy }}
              </div>
            </td>
            <td class="gv2-history-updated-on">{{ tr.UpdatedOn }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!fetchingStudentUpdateHistory && pagedHistoryList.length === 0" class="gv2-dochub-state gv2-dochub-empty">
        <i class="ri-history-line"></i>
        <p>{{ 'groupsV2.noUpdateHistoryFound' | translate }}</p>
      </div>
    </div>

    <div class="gv2-history-footer" *ngIf="!fetchingStudentUpdateHistory && filteredHistoryList.length > 0">
      <div class="gv2-showing-text">
        {{ 'groupsV2.showingChangesReport' | translate: { from: historyShowingFrom, to: historyShowingTo, total: filteredHistoryList.length } }}
      </div>
      <div class="gv2-history-pagination">
        <button type="button" class="gv2-page-btn" [disabled]="historyPageIndex === 0" (click)="goToHistoryPrevPage()">{{ 'groupsV2.prev' | translate }}</button>
        <button type="button" class="gv2-page-btn active">{{ historyPageIndex + 1 }}</button>
        <button type="button" class="gv2-page-btn" [disabled]="historyPageIndex >= historyTotalPages - 1" (click)="goToHistoryNextPage()">{{ 'groupsV2.next' | translate }}</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Enlarged image preview for history image/document values -->
<p-dialog [(visible)]="isHistoryImagePreviewOpen" [modal]="true" [closable]="true" [draggable]="false"
  [resizable]="false" header="Preview" styleClass="gv2-history-image-preview-dialog">
  <img *ngIf="historyImagePreviewUrl" [src]="historyImagePreviewUrl" alt="" class="gv2-history-image-preview-full" />
</p-dialog>

<!-- Shared in-app document preview overlay (image or PDF), matching admission-v2's document preview overlay -->
<div class="gv2-doc-preview-overlay" *ngIf="isDocPreviewOpen" (click)="closeDocPreview()">
  <button type="button" class="gv2-doc-preview-close-btn" (click)="closeDocPreview()">
    <i class="ri-close-line"></i>
  </button>
  <div class="gv2-doc-preview-content" [class.gv2-doc-preview-content-doc]="docPreviewIsPdf"
    (click)="$event.stopPropagation()">
    <ng-container *ngIf="!docPreviewIsPdf; else gv2DocPreviewPdf">
      <img [src]="docPreviewUrl" [alt]="docPreviewLabel" class="gv2-doc-preview-image" />
    </ng-container>
    <ng-template #gv2DocPreviewPdf>
      <iframe [src]="docPreviewSafeUrl" class="gv2-doc-preview-iframe" title="Document preview"></iframe>
    </ng-template>
    <div class="gv2-doc-preview-label">{{ docPreviewLabel }}</div>
  </div>
</div>

<!-- Self-contained bulk ID card modal -->
<div class="gv2-overlay" *ngIf="openIdCardPopup" (click)="closeIdCardBuilder()">
  <div class="gv2-modal gv2-modal-wide" (click)="$event.stopPropagation()">
    <div class="gv2-modal-header">
      <h3 *ngIf="!isIdCardGenerated">{{ 'groupsV2.generateIdCardCount' | translate: { count: selectedStudentIds.length } }}</h3>
      <h3 *ngIf="isIdCardGenerated">{{ 'groupsV2.congratulations' | translate }}</h3>
      <i class="ri-close-large-line" (click)="closeIdCardBuilder()"></i>
    </div>
    <div class="gv2-modal-body">
      <div *ngIf="!isIdCardGenerated && isFetchingIdCard" class="gv2-empty">{{ 'groupsV2.loadingTemplates' | translate }}</div>
      <div *ngIf="!isIdCardGenerated && !isFetchingIdCard && idCardTemplates.length === 0" class="gv2-empty">{{ 'groupsV2.noIdCardTemplates' | translate }}</div>
      <div class="gv2-template-grid" *ngIf="!isIdCardGenerated && !isFetchingIdCard && idCardTemplates.length > 0">
        <div class="gv2-template-item" *ngFor="let tpl of idCardTemplates"
             [class.selected]="tpl.isSelected" (click)="selectIdCardTemplate(tpl.templateId)">
          <div class="gv2-template-preview">
            <img [src]="tpl.defaultTemplateImageUrl" [alt]="tpl.templateName || ('Template ' + tpl.templateId)" />
            <div class="gv2-template-selected-badge" *ngIf="tpl.isSelected">
              <i class="ri-check-line"></i>
            </div>
          </div>
          <span class="gv2-template-name">{{ tpl.templateName || (('groupsV2.templateFallbackName' | translate: { id: tpl.templateId })) }}</span>
        </div>
      </div>
      <div *ngIf="isIdCardGenerated" class="gv2-success-state">
        <div class="gv2-success-badge"><i class="ri-check-line"></i></div>
        <p>{{ 'groupsV2.idCardScheduledSuccess' | translate }}</p>
      </div>
    </div>
    <div class="gv2-modal-footer" *ngIf="!isIdCardGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeIdCardBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="isGeneratingId" (click)="generateIdCardForSelection()">
        {{ (isGeneratingId ? 'groupsV2.generating' : 'groupsV2.generate') | translate }}
      </button>
    </div>
    <div class="gv2-modal-footer" *ngIf="isIdCardGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeIdCardBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" (click)="viewGeneratedIdCards()">{{ 'groupsV2.viewIdCards' | translate }}</button>
    </div>
  </div>
</div>

<!-- Self-contained bulk Staff ID Card modal - mirrors the student ID card
     builder above exactly, just backed by getStaffIdCardTemplate()/
     generateStaffIdCard() and /id-card/staff instead. -->
<div class="gv2-overlay" *ngIf="openStaffIdCardPopup" (click)="closeStaffIdCardBuilder()">
  <div class="gv2-modal gv2-modal-wide" (click)="$event.stopPropagation()">
    <div class="gv2-modal-header">
      <h3 *ngIf="!isStaffIdCardGenerated">{{ 'groupsV2.generateIdCardCount' | translate: { count: selectedStaffIdsForPrint.length } }}</h3>
      <h3 *ngIf="isStaffIdCardGenerated">{{ 'groupsV2.congratulations' | translate }}</h3>
      <i class="ri-close-large-line" (click)="closeStaffIdCardBuilder()"></i>
    </div>
    <div class="gv2-modal-body">
      <div *ngIf="!isStaffIdCardGenerated && isFetchingStaffIdCard" class="gv2-empty">{{ 'groupsV2.loadingTemplates' | translate }}</div>
      <div *ngIf="!isStaffIdCardGenerated && !isFetchingStaffIdCard && staffIdCardTemplates.length === 0" class="gv2-empty">{{ 'groupsV2.noIdCardTemplates' | translate }}</div>
      <div class="gv2-template-grid" *ngIf="!isStaffIdCardGenerated && !isFetchingStaffIdCard && staffIdCardTemplates.length > 0">
        <div class="gv2-template-item" *ngFor="let tpl of staffIdCardTemplates"
             [class.selected]="tpl.isSelected" (click)="selectStaffIdCardTemplate(tpl.templateId)">
          <div class="gv2-template-preview">
            <img [src]="tpl.defaultTemplateImageUrl" [alt]="tpl.templateName || ('Template ' + tpl.templateId)" />
            <div class="gv2-template-selected-badge" *ngIf="tpl.isSelected">
              <i class="ri-check-line"></i>
            </div>
          </div>
          <span class="gv2-template-name">{{ tpl.templateName || (('groupsV2.templateFallbackName' | translate: { id: tpl.templateId })) }}</span>
        </div>
      </div>
      <div *ngIf="isStaffIdCardGenerated" class="gv2-success-state">
        <div class="gv2-success-badge"><i class="ri-check-line"></i></div>
        <p>{{ 'groupsV2.idCardScheduledSuccess' | translate }}</p>
      </div>
    </div>
    <div class="gv2-modal-footer" *ngIf="!isStaffIdCardGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeStaffIdCardBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="isGeneratingStaffId" (click)="generateStaffIdCardForSelection()">
        {{ (isGeneratingStaffId ? 'groupsV2.generating' : 'groupsV2.generate') | translate }}
      </button>
    </div>
    <div class="gv2-modal-footer" *ngIf="isStaffIdCardGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeStaffIdCardBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" (click)="viewGeneratedStaffIdCards()">{{ 'groupsV2.viewIdCards' | translate }}</button>
    </div>
  </div>
</div>

<!-- Self-contained bulk TC (Transfer Certificate) modal -->
<div class="gv2-overlay" *ngIf="openTcPopup" (click)="closeTcBuilder()">
  <div class="gv2-modal" (click)="$event.stopPropagation()">
    <div class="gv2-modal-header">
      <h3 *ngIf="!isTcGenerated">{{ 'groupsV2.generateTransferCertificate' | translate }}</h3>
      <h3 *ngIf="isTcGenerated">{{ 'groupsV2.tcGenerationInProcess' | translate }}</h3>
      <i class="ri-close-large-line" (click)="closeTcBuilder()"></i>
    </div>
    <div class="gv2-modal-body">
      <p *ngIf="!isTcGenerated" class="gv2-tc-confirm-text">{{ 'groupsV2.tcConfirmText' | translate: { count: selectedStudentIds.length } }}</p>
      <div *ngIf="isTcGenerated" class="gv2-success-state">
        <div class="gv2-success-badge"><i class="ri-check-line"></i></div>
        <p>{{ 'groupsV2.tcGeneratingHint' | translate }}</p>
        <span class="gv2-tc-job-id" *ngIf="tcJobId">{{ 'groupsV2.jobIdLabel' | translate: { id: tcJobId } }}</span>
      </div>
    </div>
    <div class="gv2-modal-footer" *ngIf="!isTcGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeTcBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" [disabled]="isGeneratingTc" (click)="generateTcForSelection()">
        {{ (isGeneratingTc ? 'groupsV2.generating' : 'groupsV2.generate') | translate }}
      </button>
    </div>
    <div class="gv2-modal-footer" *ngIf="isTcGenerated">
      <button type="button" class="gv2-btn-outline" (click)="closeTcBuilder()">{{ 'groupsV2.close' | translate }}</button>
      <button type="button" class="gv2-btn-gradient" (click)="viewGeneratedTc()">{{ 'groupsV2.viewTransferCertificate' | translate }}</button>
    </div>
  </div>
</div>
</div>
</div>
</div>
